
var Rive = (() => {
  var _scriptDir = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : undefined;
  
  return (
function(moduleArg = {}) {

var l = moduleArg, aa, ba;
l.ready = new Promise((a, b) => {
  aa = a;
  ba = b;
});
function ca() {
  function a(g) {
    const k = d;
    c = b = 0;
    d = new Map();
    k.forEach(p => {
      try {
        p(g);
      } catch (n) {
        console.error(n);
      }
    });
    this.kb();
    e && e.Mb();
  }
  let b = 0, c = 0, d = new Map(), e = null, f = null;
  this.requestAnimationFrame = function(g) {
    b || (b = requestAnimationFrame(a.bind(this)));
    const k = ++c;
    d.set(k, g);
    return k;
  };
  this.cancelAnimationFrame = function(g) {
    d.delete(g);
    b && 0 == d.size && (cancelAnimationFrame(b), b = 0);
  };
  this.Kb = function(g) {
    f && (document.body.remove(f), f = null);
    g || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", g = function(k) {
      f.innerHTML = "RIVE FPS " + k.toFixed(1);
    }, document.body.appendChild(f));
    e = new function() {
      let k = 0, p = 0;
      this.Mb = function() {
        var n = performance.now();
        p ? (++k, n -= p, 1000 < n && (g(1000 * k / n), k = p = 0)) : (p = n, k = 0);
      };
    }();
  };
  this.kb = function() {
  };
}
function da() {
  console.assert(!0);
  const a = new Map();
  let b = -Infinity;
  this.push = function(c) {
    c = c + 255 >> 8;
    a.has(c) && clearTimeout(a.get(c));
    a.set(c, setTimeout(function() {
      a.delete(c);
      0 == a.length ? b = -Infinity : c == b && (b = Math.max(...a.keys()), console.assert(b < c));
    }, 1000));
    b = Math.max(c, b);
    return b << 8;
  };
}
const ea = l.onRuntimeInitialized;
l.onRuntimeInitialized = function() {
  ea && ea();
  let a = l.decodeAudio;
  l.decodeAudio = function(e, f) {
    e = a(e);
    f(e);
  };
  let b = l.decodeFont;
  l.decodeFont = function(e, f) {
    e = b(e);
    f(e);
  };
  const c = l.FileAssetLoader;
  l.ptrToAsset = e => {
    let f = l.ptrToFileAsset(e);
    return f.isImage ? l.ptrToImageAsset(e) : f.isFont ? l.ptrToFontAsset(e) : f.isAudio ? l.ptrToAudioAsset(e) : f;
  };
  l.CustomFileAssetLoader = c.extend("CustomFileAssetLoader", {__construct:function({loadContents:e}) {
    this.__parent.__construct.call(this);
    this.Bb = e;
  }, loadContents:function(e, f) {
    e = l.ptrToAsset(e);
    return this.Bb(e, f);
  },});
  l.CDNFileAssetLoader = c.extend("CDNFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
  }, loadContents:function(e) {
    let f = l.ptrToAsset(e);
    e = f.cdnUuid;
    if ("" === e) {
      return !1;
    }
    (function(g, k) {
      var p = new XMLHttpRequest();
      p.responseType = "arraybuffer";
      p.onreadystatechange = function() {
        4 == p.readyState && 200 == p.status && k(p);
      };
      p.open("GET", g, !0);
      p.send(null);
    })(f.cdnBaseUrl + "/" + e, g => {
      f.decode(new Uint8Array(g.response));
    });
    return !0;
  },});
  l.FallbackFileAssetLoader = c.extend("FallbackFileAssetLoader", {__construct:function() {
    this.__parent.__construct.call(this);
    this.fb = [];
  }, addLoader:function(e) {
    this.fb.push(e);
  }, loadContents:function(e, f) {
    for (let g of this.fb) {
      if (g.loadContents(e, f)) {
        return !0;
      }
    }
    return !1;
  },});
  let d = l.computeAlignment;
  l.computeAlignment = function(e, f, g, k, p = 1.0) {
    return d.call(this, e, f, g, k, p);
  };
};
const fa = l.onRuntimeInitialized;
l.onRuntimeInitialized = function() {
  function a(r) {
    this.F = r;
    this.yb = r.getContext("2d");
    this.Db = e;
    this.R = [];
    this.ja = 0;
    this.clear = function() {
      console.assert(0 == this.ja);
      this.R = [];
      f.delete(this);
    };
    this.save = function() {
      ++this.ja;
      this.R.push(e.save.bind(e));
    };
    this.restore = function() {
      0 < this.ja && (this.R.push(e.restore.bind(e)), --this.ja);
    };
    this.transform = function(u) {
      this.R.push(e.transform.bind(e, u));
    };
    this.align = function(u, z, B, C, O = 1.0) {
      this.R.push(e.align.bind(e, u, z, B, C, O));
    };
    this.flush = function() {
      console.assert(0 == this.ja);
      f.add(this);
      d && c();
    };
  }
  function b(r) {
    var u = {alpha:1, depth:0, stencil:8, antialias:0, premultipliedAlpha:1, preserveDrawingBuffer:0, powerPreference:"high-performance", failIfMajorPerformanceCaveat:0, enableExtensionsByDefault:1, explicitSwapControl:0, renderViaOffscreenBackBuffer:0,}, z = r.getContext("webgl2", u);
    z || (z = r.getContext("webgl", u));
    var B = z, C = ha(ia), O = {handle:C, attributes:u, version:u.Dc, Ta:B};
    B.canvas && (B.canvas.pc = O);
    ia[C] = O;
    ("undefined" == typeof u.Jb || u.Jb) && ka(O);
    la(C);
    u = g(r.width, r.height);
    u.Ab = C;
    u.F = r;
    u.Va = r.width;
    u.Ua = r.height;
    u.zb = z;
    return u;
  }
  function c() {
    if (e) {
      var r = e.Cb, u = 0, z = 0, B = 0, C = Array(f.size), O = 0;
      for (var M of f) {
        M.da = Math.min(M.F.width, r), M.ca = Math.min(M.F.height, r), M.Ja = M.ca * M.da, u = Math.max(u, M.da), z = Math.max(z, M.ca), B += M.Ja, C[O++] = M;
      }
      f.clear();
      if (!(0 >= B)) {
        u = 1 << (0 >= u ? 0 : 32 - Math.clz32(u - 1));
        for (z = 1 << (0 >= z ? 0 : 32 - Math.clz32(z - 1)); z * u < B;) {
          u <= z ? u *= 2 : z *= 2;
        }
        u = Math.min(u, r);
        u = Math.min(z, r);
        C.sort((ja, Gb) => Gb.Ja - ja.Ja);
        B = new l.DynamicRectanizer(r);
        for (M = 0; M < C.length;) {
          B.reset(u, z);
          for (O = M; O < C.length; ++O) {
            var P = C[O], J = B.addRect(P.da, P.ca);
            if (0 > J) {
              console.assert(O > M);
              break;
            }
            P.pa = J & 65535;
            P.qa = J >> 16;
          }
          P = p.push(B.drawWidth());
          J = n.push(B.drawHeight());
          console.assert(P >= B.drawWidth());
          console.assert(J >= B.drawHeight());
          console.assert(P <= r);
          console.assert(J <= r);
          e.F.width != P && (e.F.width = P);
          e.F.height != J && (e.F.height = J);
          e.clear();
          for (P = M; P < O; ++P) {
            J = C[P];
            e.saveClipRect(J.pa, J.qa, J.pa + J.da, J.qa + J.ca);
            let ja = new l.Mat2D();
            ja.xx = J.da / J.F.width;
            ja.yy = J.ca / J.F.height;
            ja.xy = ja.yx = 0;
            ja.tx = J.pa;
            ja.ty = J.qa;
            e.transform(ja);
            for (const Gb of J.R) {
              Gb();
            }
            e.restoreClipRect();
            J.R = [];
          }
          for (e.flush(); M < O; ++M) {
            P = C[M], J = P.yb, J.globalCompositeOperation = "copy", J.drawImage(e.F, P.pa, P.qa, P.da, P.ca, 0, 0, P.F.width, P.F.height);
          }
          M = O;
        }
      }
    }
  }
  fa && fa();
  const d = navigator.userAgent.match(/firefox|fxios/i);
  let e = null;
  const f = new Set(), g = l.makeRenderer;
  l.makeRenderer = function(r, u) {
    return u ? (e || (e = b(document.createElement("canvas")), u = e.zb, e.Cb = Math.min(u.getParameter(u.MAX_RENDERBUFFER_SIZE), u.getParameter(u.MAX_TEXTURE_SIZE))), new a(r)) : b(r);
  };
  const k = l.Artboard.prototype.draw;
  l.Artboard.prototype.draw = function(r) {
    r.R ? r.R.push(k.bind(this, r.Db)) : k.call(this, r);
  };
  const p = new da(), n = new da(), t = new ca();
  l.requestAnimationFrame = t.requestAnimationFrame.bind(t);
  l.cancelAnimationFrame = t.cancelAnimationFrame.bind(t);
  l.enableFPSCounter = t.Kb.bind(t);
  t.kb = c;
  l.resolveAnimationFrame = c;
  let w = l.load;
  l.load = function(r, u, z = !0) {
    const B = new l.FallbackFileAssetLoader();
    void 0 !== u && B.addLoader(u);
    z && (u = new l.CDNFileAssetLoader(), B.addLoader(u));
    return Promise.resolve(w(r, B));
  };
  const y = l.WebGLRenderer.prototype.clear;
  l.WebGLRenderer.prototype.clear = function() {
    la(this.Ab);
    const r = this.F;
    if (this.Va != r.width || this.Ua != r.height) {
      this.resize(r.width, r.height), this.Va = r.width, this.Ua = r.height;
    }
    y.call(this);
  };
  l.decodeImage = function(r, u) {
    r = l.decodeImageSkia(r);
    u(r);
  };
  let q = l.Renderer.prototype.align;
  l.Renderer.prototype.align = function(r, u, z, B, C = 1.0) {
    q.call(this, r, u, z, B, C);
  };
};
var ma = Object.assign({}, l), na = "./this.program", oa = "object" == typeof window, pa = "function" == typeof importScripts, qa = "", ra, sa;
if (oa || pa) {
  pa ? qa = self.location.href : "undefined" != typeof document && document.currentScript && (qa = document.currentScript.src), _scriptDir && (qa = _scriptDir), 0 !== qa.indexOf("blob:") ? qa = qa.substr(0, qa.replace(/[?#].*/, "").lastIndexOf("/") + 1) : qa = "", pa && (sa = a => {
    var b = new XMLHttpRequest();
    b.open("GET", a, !1);
    b.responseType = "arraybuffer";
    b.send(null);
    return new Uint8Array(b.response);
  }), ra = (a, b, c) => {
    var d = new XMLHttpRequest();
    d.open("GET", a, !0);
    d.responseType = "arraybuffer";
    d.onload = () => {
      200 == d.status || 0 == d.status && d.response ? b(d.response) : c();
    };
    d.onerror = c;
    d.send(null);
  };
}
var ta = l.print || console.log.bind(console), ua = l.printErr || console.error.bind(console);
Object.assign(l, ma);
ma = null;
l.thisProgram && (na = l.thisProgram);
var va;
l.wasmBinary && (va = l.wasmBinary);
var noExitRuntime = l.noExitRuntime || !0;
"object" != typeof WebAssembly && wa("no native wasm support detected");
var xa, m, ya = !1, v, x, A, za, D, E, F, Aa;
function Ba() {
  var a = xa.buffer;
  l.HEAP8 = v = new Int8Array(a);
  l.HEAP16 = A = new Int16Array(a);
  l.HEAP32 = D = new Int32Array(a);
  l.HEAPU8 = x = new Uint8Array(a);
  l.HEAPU16 = za = new Uint16Array(a);
  l.HEAPU32 = E = new Uint32Array(a);
  l.HEAPF32 = F = new Float32Array(a);
  l.HEAPF64 = Aa = new Float64Array(a);
}
var Ca, Da = [], Ea = [], Fa = [];
function Ga() {
  var a = l.preRun.shift();
  Da.unshift(a);
}
var Ha = 0, Ia = null, Ja = null;
function wa(a) {
  if (l.onAbort) {
    l.onAbort(a);
  }
  a = "Aborted(" + a + ")";
  ua(a);
  ya = !0;
  a = new WebAssembly.RuntimeError(a + ". Build with -sASSERTIONS for more info.");
  ba(a);
  throw a;
}
function Ka(a) {
  return a.startsWith("data:application/octet-stream;base64,");
}
var La;
La = "webgl_advanced.wasm";
if (!Ka(La)) {
  var Ma = La;
  La = l.locateFile ? l.locateFile(Ma, qa) : qa + Ma;
}
function Na(a) {
  if (a == La && va) {
    return new Uint8Array(va);
  }
  if (sa) {
    return sa(a);
  }
  throw "both async and sync fetching of the wasm failed";
}
function Oa(a) {
  if (!va && (oa || pa)) {
    if ("function" == typeof fetch && !a.startsWith("file://")) {
      return fetch(a, {credentials:"same-origin"}).then(b => {
        if (!b.ok) {
          throw "failed to load wasm binary file at '" + a + "'";
        }
        return b.arrayBuffer();
      }).catch(() => Na(a));
    }
    if (ra) {
      return new Promise((b, c) => {
        ra(a, d => b(new Uint8Array(d)), c);
      });
    }
  }
  return Promise.resolve().then(() => Na(a));
}
function Pa(a, b, c) {
  return Oa(a).then(d => WebAssembly.instantiate(d, b)).then(d => d).then(c, d => {
    ua("failed to asynchronously prepare wasm: " + d);
    wa(d);
  });
}
function Qa(a, b) {
  var c = La;
  return va || "function" != typeof WebAssembly.instantiateStreaming || Ka(c) || c.startsWith("file://") || "function" != typeof fetch ? Pa(c, a, b) : fetch(c, {credentials:"same-origin"}).then(d => WebAssembly.instantiateStreaming(d, a).then(b, function(e) {
    ua("wasm streaming compile failed: " + e);
    ua("falling back to ArrayBuffer instantiation");
    return Pa(c, a, b);
  }));
}
var Ra, Sa, Wa = {705852:(a, b, c, d, e) => {
  if ("undefined" === typeof window || void 0 === (window.AudioContext || window.webkitAudioContext)) {
    return 0;
  }
  if ("undefined" === typeof window.h) {
    window.h = {Ea:0};
    window.h.H = {};
    window.h.H.Ca = a;
    window.h.H.capture = b;
    window.h.H.La = c;
    window.h.ha = {};
    window.h.ha.stopped = d;
    window.h.ha.sb = e;
    let f = window.h;
    f.C = [];
    f.nc = function(g) {
      for (var k = 0; k < f.C.length; ++k) {
        if (null == f.C[k]) {
          return f.C[k] = g, k;
        }
      }
      f.C.push(g);
      return f.C.length - 1;
    };
    f.xb = function(g) {
      for (f.C[g] = null; 0 < f.C.length;) {
        if (null == f.C[f.C.length - 1]) {
          f.C.pop();
        } else {
          break;
        }
      }
    };
    f.Kc = function(g) {
      for (var k = 0; k < f.C.length; ++k) {
        if (f.C[k] == g) {
          return f.xb(k);
        }
      }
    };
    f.ta = function(g) {
      return f.C[g];
    };
    f.wb = ["touchend", "click"];
    f.unlock = function() {
      for (var g = 0; g < f.C.length; ++g) {
        var k = f.C[g];
        null != k && null != k.I && k.state === f.ha.sb && k.I.resume().then(() => {
          Ta(k.lb);
        }, p => {
          console.error("Failed to resume audiocontext", p);
        });
      }
      f.wb.map(function(p) {
        document.removeEventListener(p, f.unlock, !0);
      });
    };
    f.wb.map(function(g) {
      document.addEventListener(g, f.unlock, !0);
    });
  }
  window.h.Ea += 1;
  return 1;
}, 708030:() => {
  "undefined" !== typeof window.h && (--window.h.Ea, 0 === window.h.Ea && delete window.h);
}, 708194:() => void 0 !== navigator.mediaDevices && void 0 !== navigator.mediaDevices.getUserMedia, 708298:() => {
  try {
    var a = new (window.AudioContext || window.webkitAudioContext)(), b = a.sampleRate;
    a.close();
    return b;
  } catch (c) {
    return 0;
  }
}, 708469:(a, b, c, d, e, f) => {
  if ("undefined" === typeof window.h) {
    return -1;
  }
  var g = {}, k = {};
  a == window.h.H.Ca && 0 != c && (k.sampleRate = c);
  g.I = new (window.AudioContext || window.webkitAudioContext)(k);
  g.I.suspend();
  g.state = window.h.ha.stopped;
  c = 0;
  a != window.h.H.Ca && (c = b);
  g.X = g.I.createScriptProcessor(d, c, b);
  g.X.onaudioprocess = function(p) {
    if (null == g.ua || 0 == g.ua.length) {
      g.ua = new Float32Array(F.buffer, e, d * b);
    }
    if (a == window.h.H.capture || a == window.h.H.La) {
      for (var n = 0; n < b; n += 1) {
        for (var t = p.inputBuffer.getChannelData(n), w = g.ua, y = 0; y < d; y += 1) {
          w[y * b + n] = t[y];
        }
      }
      Ua(f, d, e);
    }
    if (a == window.h.H.Ca || a == window.h.H.La) {
      for (Va(f, d, e), n = 0; n < p.outputBuffer.numberOfChannels; ++n) {
        for (t = p.outputBuffer.getChannelData(n), w = g.ua, y = 0; y < d; y += 1) {
          t[y] = w[y * b + n];
        }
      }
    } else {
      for (n = 0; n < p.outputBuffer.numberOfChannels; ++n) {
        p.outputBuffer.getChannelData(n).fill(0.0);
      }
    }
  };
  a != window.h.H.capture && a != window.h.H.La || navigator.mediaDevices.getUserMedia({audio:!0, video:!1}).then(function(p) {
    g.Fa = g.I.createMediaStreamSource(p);
    g.Fa.connect(g.X);
    g.X.connect(g.I.destination);
  }).catch(function(p) {
    console.log("Failed to get user media: " + p);
  });
  a == window.h.H.Ca && g.X.connect(g.I.destination);
  g.lb = f;
  return window.h.nc(g);
}, 711346:a => window.h.ta(a).I.sampleRate, 711419:a => {
  a = window.h.ta(a);
  void 0 !== a.X && (a.X.onaudioprocess = function() {
  }, a.X.disconnect(), a.X = void 0);
  void 0 !== a.Fa && (a.Fa.disconnect(), a.Fa = void 0);
  a.I.close();
  a.I = void 0;
  a.lb = void 0;
}, 711819:a => {
  window.h.xb(a);
}, 711869:a => {
  a = window.h.ta(a);
  a.I.resume();
  a.state = window.h.ha.sb;
}, 712008:a => {
  a = window.h.ta(a);
  a.I.suspend();
  a.state = window.h.ha.stopped;
}}, Xa = a => {
  for (; 0 < a.length;) {
    a.shift()(l);
  }
}, Ya = (a, b) => {
  for (var c = 0, d = a.length - 1; 0 <= d; d--) {
    var e = a[d];
    "." === e ? a.splice(d, 1) : ".." === e ? (a.splice(d, 1), c++) : c && (a.splice(d, 1), c--);
  }
  if (b) {
    for (; c; c--) {
      a.unshift("..");
    }
  }
  return a;
}, Za = a => {
  var b = "/" === a.charAt(0), c = "/" === a.substr(-1);
  (a = Ya(a.split("/").filter(d => !!d), !b).join("/")) || b || (a = ".");
  a && c && (a += "/");
  return (b ? "/" : "") + a;
}, $a = a => {
  var b = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(a).slice(1);
  a = b[0];
  b = b[1];
  if (!a && !b) {
    return ".";
  }
  b && (b = b.substr(0, b.length - 1));
  return a + b;
}, ab = a => {
  if ("/" === a) {
    return "/";
  }
  a = Za(a);
  a = a.replace(/\/$/, "");
  var b = a.lastIndexOf("/");
  return -1 === b ? a : a.substr(b + 1);
}, bb = () => {
  if ("object" == typeof crypto && "function" == typeof crypto.getRandomValues) {
    return a => crypto.getRandomValues(a);
  }
  wa("initRandomDevice");
}, cb = a => (cb = bb())(a);
function db() {
  for (var a = "", b = !1, c = arguments.length - 1; -1 <= c && !b; c--) {
    b = 0 <= c ? arguments[c] : "/";
    if ("string" != typeof b) {
      throw new TypeError("Arguments to path.resolve must be strings");
    }
    if (!b) {
      return "";
    }
    a = b + "/" + a;
    b = "/" === b.charAt(0);
  }
  a = Ya(a.split("/").filter(d => !!d), !b).join("/");
  return (b ? "/" : "") + a || ".";
}
var eb = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, fb = (a, b, c) => {
  var d = b + c;
  for (c = b; a[c] && !(c >= d);) {
    ++c;
  }
  if (16 < c - b && a.buffer && eb) {
    return eb.decode(a.subarray(b, c));
  }
  for (d = ""; b < c;) {
    var e = a[b++];
    if (e & 128) {
      var f = a[b++] & 63;
      if (192 == (e & 224)) {
        d += String.fromCharCode((e & 31) << 6 | f);
      } else {
        var g = a[b++] & 63;
        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | g : (e & 7) << 18 | f << 12 | g << 6 | a[b++] & 63;
        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
      }
    } else {
      d += String.fromCharCode(e);
    }
  }
  return d;
}, gb = [], hb = a => {
  for (var b = 0, c = 0; c < a.length; ++c) {
    var d = a.charCodeAt(c);
    127 >= d ? b++ : 2047 >= d ? b += 2 : 55296 <= d && 57343 >= d ? (b += 4, ++c) : b += 3;
  }
  return b;
}, ib = (a, b, c, d) => {
  if (!(0 < d)) {
    return 0;
  }
  var e = c;
  d = c + d - 1;
  for (var f = 0; f < a.length; ++f) {
    var g = a.charCodeAt(f);
    if (55296 <= g && 57343 >= g) {
      var k = a.charCodeAt(++f);
      g = 65536 + ((g & 1023) << 10) | k & 1023;
    }
    if (127 >= g) {
      if (c >= d) {
        break;
      }
      b[c++] = g;
    } else {
      if (2047 >= g) {
        if (c + 1 >= d) {
          break;
        }
        b[c++] = 192 | g >> 6;
      } else {
        if (65535 >= g) {
          if (c + 2 >= d) {
            break;
          }
          b[c++] = 224 | g >> 12;
        } else {
          if (c + 3 >= d) {
            break;
          }
          b[c++] = 240 | g >> 18;
          b[c++] = 128 | g >> 12 & 63;
        }
        b[c++] = 128 | g >> 6 & 63;
      }
      b[c++] = 128 | g & 63;
    }
  }
  b[c] = 0;
  return c - e;
};
function jb(a, b) {
  var c = Array(hb(a) + 1);
  a = ib(a, c, 0, c.length);
  b && (c.length = a);
  return c;
}
var kb = [];
function lb(a, b) {
  kb[a] = {input:[], D:[], T:b};
  mb(a, nb);
}
var nb = {open:function(a) {
  var b = kb[a.node.Da];
  if (!b) {
    throw new G(43);
  }
  a.s = b;
  a.seekable = !1;
}, close:function(a) {
  a.s.T.sa(a.s);
}, sa:function(a) {
  a.s.T.sa(a.s);
}, read:function(a, b, c, d) {
  if (!a.s || !a.s.T.eb) {
    throw new G(60);
  }
  for (var e = 0, f = 0; f < d; f++) {
    try {
      var g = a.s.T.eb(a.s);
    } catch (k) {
      throw new G(29);
    }
    if (void 0 === g && 0 === e) {
      throw new G(6);
    }
    if (null === g || void 0 === g) {
      break;
    }
    e++;
    b[c + f] = g;
  }
  e && (a.node.timestamp = Date.now());
  return e;
}, write:function(a, b, c, d) {
  if (!a.s || !a.s.T.Oa) {
    throw new G(60);
  }
  try {
    for (var e = 0; e < d; e++) {
      a.s.T.Oa(a.s, b[c + e]);
    }
  } catch (f) {
    throw new G(29);
  }
  d && (a.node.timestamp = Date.now());
  return e;
},}, ob = {eb:function() {
  a: {
    if (!gb.length) {
      var a = null;
      "undefined" != typeof window && "function" == typeof window.prompt ? (a = window.prompt("Input: "), null !== a && (a += "\n")) : "function" == typeof readline && (a = readline(), null !== a && (a += "\n"));
      if (!a) {
        a = null;
        break a;
      }
      gb = jb(a, !0);
    }
    a = gb.shift();
  }
  return a;
}, Oa:function(a, b) {
  null === b || 10 === b ? (ta(fb(a.D, 0)), a.D = []) : 0 != b && a.D.push(b);
}, sa:function(a) {
  a.D && 0 < a.D.length && (ta(fb(a.D, 0)), a.D = []);
}, Wb:function() {
  return {uc:25856, wc:5, tc:191, vc:35387, sc:[3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,]};
}, Xb:function() {
  return 0;
}, Yb:function() {
  return [24, 80];
},}, pb = {Oa:function(a, b) {
  null === b || 10 === b ? (ua(fb(a.D, 0)), a.D = []) : 0 != b && a.D.push(b);
}, sa:function(a) {
  a.D && 0 < a.D.length && (ua(fb(a.D, 0)), a.D = []);
},};
function qb(a, b) {
  var c = a.j ? a.j.length : 0;
  c >= b || (b = Math.max(b, c * (1048576 > c ? 2.0 : 1.125) >>> 0), 0 != c && (b = Math.max(b, 256)), c = a.j, a.j = new Uint8Array(b), 0 < a.v && a.j.set(c.subarray(0, a.v), 0));
}
var H = {N:null, S() {
  return H.createNode(null, "/", 16895, 0);
}, createNode(a, b, c, d) {
  if (24576 === (c & 61440) || 4096 === (c & 61440)) {
    throw new G(63);
  }
  H.N || (H.N = {dir:{node:{W:H.l.W, O:H.l.O, ka:H.l.ka, Aa:H.l.Aa, qb:H.l.qb, vb:H.l.vb, rb:H.l.rb, ob:H.l.ob, Ga:H.l.Ga}, stream:{$:H.m.$}}, file:{node:{W:H.l.W, O:H.l.O}, stream:{$:H.m.$, read:H.m.read, write:H.m.write, ra:H.m.ra, hb:H.m.hb, jb:H.m.jb}}, link:{node:{W:H.l.W, O:H.l.O, la:H.l.la}, stream:{}}, Wa:{node:{W:H.l.W, O:H.l.O}, stream:rb}});
  c = sb(a, b, c, d);
  16384 === (c.mode & 61440) ? (c.l = H.N.dir.node, c.m = H.N.dir.stream, c.j = {}) : 32768 === (c.mode & 61440) ? (c.l = H.N.file.node, c.m = H.N.file.stream, c.v = 0, c.j = null) : 40960 === (c.mode & 61440) ? (c.l = H.N.link.node, c.m = H.N.link.stream) : 8192 === (c.mode & 61440) && (c.l = H.N.Wa.node, c.m = H.N.Wa.stream);
  c.timestamp = Date.now();
  a && (a.j[b] = c, a.timestamp = c.timestamp);
  return c;
}, Ac(a) {
  return a.j ? a.j.subarray ? a.j.subarray(0, a.v) : new Uint8Array(a.j) : new Uint8Array(0);
}, l:{W(a) {
  var b = {};
  b.zc = 8192 === (a.mode & 61440) ? a.id : 1;
  b.Cc = a.id;
  b.mode = a.mode;
  b.Gc = 1;
  b.uid = 0;
  b.Bc = 0;
  b.Da = a.Da;
  16384 === (a.mode & 61440) ? b.size = 4096 : 32768 === (a.mode & 61440) ? b.size = a.v : 40960 === (a.mode & 61440) ? b.size = a.link.length : b.size = 0;
  b.qc = new Date(a.timestamp);
  b.Ec = new Date(a.timestamp);
  b.xc = new Date(a.timestamp);
  b.Eb = 4096;
  b.rc = Math.ceil(b.size / b.Eb);
  return b;
}, O(a, b) {
  void 0 !== b.mode && (a.mode = b.mode);
  void 0 !== b.timestamp && (a.timestamp = b.timestamp);
  if (void 0 !== b.size && (b = b.size, a.v != b)) {
    if (0 == b) {
      a.j = null, a.v = 0;
    } else {
      var c = a.j;
      a.j = new Uint8Array(b);
      c && a.j.set(c.subarray(0, Math.min(b, a.v)));
      a.v = b;
    }
  }
}, ka() {
  throw tb[44];
}, Aa(a, b, c, d) {
  return H.createNode(a, b, c, d);
}, qb(a, b, c) {
  if (16384 === (a.mode & 61440)) {
    try {
      var d = ub(b, c);
    } catch (f) {
    }
    if (d) {
      for (var e in d.j) {
        throw new G(55);
      }
    }
  }
  delete a.parent.j[a.name];
  a.parent.timestamp = Date.now();
  a.name = c;
  b.j[c] = a;
  b.timestamp = a.parent.timestamp;
  a.parent = b;
}, vb(a, b) {
  delete a.j[b];
  a.timestamp = Date.now();
}, rb(a, b) {
  var c = ub(a, b), d;
  for (d in c.j) {
    throw new G(55);
  }
  delete a.j[b];
  a.timestamp = Date.now();
}, ob(a) {
  var b = [".", ".."], c;
  for (c in a.j) {
    a.j.hasOwnProperty(c) && b.push(c);
  }
  return b;
}, Ga(a, b, c) {
  a = H.createNode(a, b, 41471, 0);
  a.link = c;
  return a;
}, la(a) {
  if (40960 !== (a.mode & 61440)) {
    throw new G(28);
  }
  return a.link;
},}, m:{read(a, b, c, d, e) {
  var f = a.node.j;
  if (e >= a.node.v) {
    return 0;
  }
  a = Math.min(a.node.v - e, d);
  if (8 < a && f.subarray) {
    b.set(f.subarray(e, e + a), c);
  } else {
    for (d = 0; d < a; d++) {
      b[c + d] = f[e + d];
    }
  }
  return a;
}, write(a, b, c, d, e, f) {
  b.buffer === v.buffer && (f = !1);
  if (!d) {
    return 0;
  }
  a = a.node;
  a.timestamp = Date.now();
  if (b.subarray && (!a.j || a.j.subarray)) {
    if (f) {
      return a.j = b.subarray(c, c + d), a.v = d;
    }
    if (0 === a.v && 0 === e) {
      return a.j = b.slice(c, c + d), a.v = d;
    }
    if (e + d <= a.v) {
      return a.j.set(b.subarray(c, c + d), e), d;
    }
  }
  qb(a, e + d);
  if (a.j.subarray && b.subarray) {
    a.j.set(b.subarray(c, c + d), e);
  } else {
    for (f = 0; f < d; f++) {
      a.j[e + f] = b[c + f];
    }
  }
  a.v = Math.max(a.v, e + d);
  return d;
}, $(a, b, c) {
  1 === c ? b += a.position : 2 === c && 32768 === (a.node.mode & 61440) && (b += a.node.v);
  if (0 > b) {
    throw new G(28);
  }
  return b;
}, ra(a, b, c) {
  qb(a.node, b + c);
  a.node.v = Math.max(a.node.v, b + c);
}, hb(a, b, c, d, e) {
  if (32768 !== (a.node.mode & 61440)) {
    throw new G(43);
  }
  a = a.node.j;
  if (e & 2 || a.buffer !== v.buffer) {
    if (0 < c || c + b < a.length) {
      a.subarray ? a = a.subarray(c, c + b) : a = Array.prototype.slice.call(a, c, c + b);
    }
    c = !0;
    b = 65536 * Math.ceil(b / 65536);
    (e = vb(65536, b)) ? (x.fill(0, e, e + b), b = e) : b = 0;
    if (!b) {
      throw new G(48);
    }
    v.set(a, b);
  } else {
    c = !1, b = a.byteOffset;
  }
  return {o:b, L:c};
}, jb(a, b, c, d) {
  H.m.write(a, b, 0, d, c, !1);
  return 0;
},},};
function wb(a, b) {
  var c = 0;
  a && (c |= 365);
  b && (c |= 146);
  return c;
}
var xb = null, yb = {}, zb = [], Ab = 1, Bb = null, Cb = !0, G = null, tb = {}, Eb = (a, b = {}) => {
  a = db(a);
  if (!a) {
    return {path:"", node:null};
  }
  b = Object.assign({bb:!0, Qa:0}, b);
  if (8 < b.Qa) {
    throw new G(32);
  }
  a = a.split("/").filter(g => !!g);
  for (var c = xb, d = "/", e = 0; e < a.length; e++) {
    var f = e === a.length - 1;
    if (f && b.parent) {
      break;
    }
    c = ub(c, a[e]);
    d = Za(d + "/" + a[e]);
    c.Ba && (!f || f && b.bb) && (c = c.Ba.root);
    if (!f || b.ab) {
      for (f = 0; 40960 === (c.mode & 61440);) {
        if (c = Db(d), d = db($a(d), c), c = Eb(d, {Qa:b.Qa + 1}).node, 40 < f++) {
          throw new G(32);
        }
      }
    }
  }
  return {path:d, node:c};
}, Fb = a => {
  for (var b;;) {
    if (a === a.parent) {
      return a = a.S.ib, b ? "/" !== a[a.length - 1] ? `${a}/${b}` : a + b : a;
    }
    b = b ? `${a.name}/${b}` : a.name;
    a = a.parent;
  }
}, Hb = (a, b) => {
  for (var c = 0, d = 0; d < b.length; d++) {
    c = (c << 5) - c + b.charCodeAt(d) | 0;
  }
  return (a + c >>> 0) % Bb.length;
}, ub = (a, b) => {
  var c;
  if (c = (c = Ib(a, "x")) ? c : a.l.ka ? 0 : 2) {
    throw new G(c, a);
  }
  for (c = Bb[Hb(a.id, b)]; c; c = c.ac) {
    var d = c.name;
    if (c.parent.id === a.id && d === b) {
      return c;
    }
  }
  return a.l.ka(a, b);
}, sb = (a, b, c, d) => {
  a = new Jb(a, b, c, d);
  b = Hb(a.parent.id, a.name);
  a.ac = Bb[b];
  return Bb[b] = a;
}, Kb = a => {
  var b = ["r", "w", "rw"][a & 3];
  a & 512 && (b += "w");
  return b;
}, Ib = (a, b) => {
  if (Cb) {
    return 0;
  }
  if (!b.includes("r") || a.mode & 292) {
    if (b.includes("w") && !(a.mode & 146) || b.includes("x") && !(a.mode & 73)) {
      return 2;
    }
  } else {
    return 2;
  }
  return 0;
}, Lb = (a, b) => {
  try {
    return ub(a, b), 20;
  } catch (c) {
  }
  return Ib(a, "wx");
}, Mb = () => {
  for (var a = 0; 4096 >= a; a++) {
    if (!zb[a]) {
      return a;
    }
  }
  throw new G(33);
}, Nb = a => {
  a = zb[a];
  if (!a) {
    throw new G(8);
  }
  return a;
}, Pb = (a, b = -1) => {
  Ob || (Ob = function() {
    this.h = {};
  }, Ob.prototype = {}, Object.defineProperties(Ob.prototype, {object:{get() {
    return this.node;
  }, set(c) {
    this.node = c;
  }}, flags:{get() {
    return this.h.flags;
  }, set(c) {
    this.h.flags = c;
  },}, position:{get() {
    return this.h.position;
  }, set(c) {
    this.h.position = c;
  },},}));
  a = Object.assign(new Ob(), a);
  -1 == b && (b = Mb());
  a.V = b;
  return zb[b] = a;
}, rb = {open:a => {
  a.m = yb[a.node.Da].m;
  a.m.open && a.m.open(a);
}, $:() => {
  throw new G(70);
},}, mb = (a, b) => {
  yb[a] = {m:b};
}, Qb = (a, b) => {
  var c = "/" === b, d = !b;
  if (c && xb) {
    throw new G(10);
  }
  if (!c && !d) {
    var e = Eb(b, {bb:!1});
    b = e.path;
    e = e.node;
    if (e.Ba) {
      throw new G(10);
    }
    if (16384 !== (e.mode & 61440)) {
      throw new G(54);
    }
  }
  b = {type:a, Ic:{}, ib:b, $b:[]};
  a = a.S(b);
  a.S = b;
  b.root = a;
  c ? xb = a : e && (e.Ba = b, e.S && e.S.$b.push(b));
}, Rb = (a, b, c) => {
  var d = Eb(a, {parent:!0}).node;
  a = ab(a);
  if (!a || "." === a || ".." === a) {
    throw new G(28);
  }
  var e = Lb(d, a);
  if (e) {
    throw new G(e);
  }
  if (!d.l.Aa) {
    throw new G(63);
  }
  return d.l.Aa(d, a, b, c);
}, Sb = (a, b, c) => {
  "undefined" == typeof c && (c = b, b = 438);
  Rb(a, b | 8192, c);
}, Tb = (a, b) => {
  if (!db(a)) {
    throw new G(44);
  }
  var c = Eb(b, {parent:!0}).node;
  if (!c) {
    throw new G(44);
  }
  b = ab(b);
  var d = Lb(c, b);
  if (d) {
    throw new G(d);
  }
  if (!c.l.Ga) {
    throw new G(63);
  }
  c.l.Ga(c, b, a);
}, Db = a => {
  a = Eb(a).node;
  if (!a) {
    throw new G(44);
  }
  if (!a.l.la) {
    throw new G(28);
  }
  return db(Fb(a.parent), a.l.la(a));
}, Vb = (a, b, c) => {
  if ("" === a) {
    throw new G(44);
  }
  if ("string" == typeof b) {
    var d = {r:0, "r+":2, w:577, "w+":578, a:1089, "a+":1090,}[b];
    if ("undefined" == typeof d) {
      throw Error(`Unknown file open mode: ${b}`);
    }
    b = d;
  }
  c = b & 64 ? ("undefined" == typeof c ? 438 : c) & 4095 | 32768 : 0;
  if ("object" == typeof a) {
    var e = a;
  } else {
    a = Za(a);
    try {
      e = Eb(a, {ab:!(b & 131072)}).node;
    } catch (f) {
    }
  }
  d = !1;
  if (b & 64) {
    if (e) {
      if (b & 128) {
        throw new G(20);
      }
    } else {
      e = Rb(a, c, 0), d = !0;
    }
  }
  if (!e) {
    throw new G(44);
  }
  8192 === (e.mode & 61440) && (b &= -513);
  if (b & 65536 && 16384 !== (e.mode & 61440)) {
    throw new G(54);
  }
  if (!d && (c = e ? 40960 === (e.mode & 61440) ? 32 : 16384 === (e.mode & 61440) && ("r" !== Kb(b) || b & 512) ? 31 : Ib(e, Kb(b)) : 44)) {
    throw new G(c);
  }
  if (b & 512 && !d) {
    c = e;
    c = "string" == typeof c ? Eb(c, {ab:!0}).node : c;
    if (!c.l.O) {
      throw new G(63);
    }
    if (16384 === (c.mode & 61440)) {
      throw new G(31);
    }
    if (32768 !== (c.mode & 61440)) {
      throw new G(28);
    }
    if (d = Ib(c, "w")) {
      throw new G(d);
    }
    c.l.O(c, {size:0, timestamp:Date.now()});
  }
  b &= -131713;
  e = Pb({node:e, path:Fb(e), flags:b, seekable:!0, position:0, m:e.m, oc:[], error:!1});
  e.m.open && e.m.open(e);
  !l.logReadFiles || b & 1 || (Ub || (Ub = {}), a in Ub || (Ub[a] = 1));
  return e;
}, Wb = (a, b, c) => {
  if (null === a.V) {
    throw new G(8);
  }
  if (!a.seekable || !a.m.$) {
    throw new G(70);
  }
  if (0 != c && 1 != c && 2 != c) {
    throw new G(28);
  }
  a.position = a.m.$(a, b, c);
  a.oc = [];
}, Xb = () => {
  G || (G = function(a, b) {
    this.name = "ErrnoError";
    this.node = b;
    this.dc = function(c) {
      this.Z = c;
    };
    this.dc(a);
    this.message = "FS error";
  }, G.prototype = Error(), G.prototype.constructor = G, [44].forEach(a => {
    tb[a] = new G(a);
    tb[a].stack = "<generic error, no stack>";
  }));
}, Yb, $b = (a, b, c) => {
  a = Za("/dev/" + a);
  var d = wb(!!b, !!c);
  Zb || (Zb = 64);
  var e = Zb++ << 8 | 0;
  mb(e, {open:f => {
    f.seekable = !1;
  }, close:() => {
    c && c.buffer && c.buffer.length && c(10);
  }, read:(f, g, k, p) => {
    for (var n = 0, t = 0; t < p; t++) {
      try {
        var w = b();
      } catch (y) {
        throw new G(29);
      }
      if (void 0 === w && 0 === n) {
        throw new G(6);
      }
      if (null === w || void 0 === w) {
        break;
      }
      n++;
      g[k + t] = w;
    }
    n && (f.node.timestamp = Date.now());
    return n;
  }, write:(f, g, k, p) => {
    for (var n = 0; n < p; n++) {
      try {
        c(g[k + n]);
      } catch (t) {
        throw new G(29);
      }
    }
    p && (f.node.timestamp = Date.now());
    return n;
  }});
  Sb(a, d, e);
}, Zb, ac = {}, Ob, Ub, bc = void 0;
function cc() {
  bc += 4;
  return D[bc - 4 >> 2];
}
function dc(a) {
  if (void 0 === a) {
    return "_unknown";
  }
  a = a.replace(/[^a-zA-Z0-9_]/g, "$");
  var b = a.charCodeAt(0);
  return 48 <= b && 57 >= b ? `_${a}` : a;
}
function ec(a, b) {
  a = dc(a);
  return {[a]:function() {
    return b.apply(this, arguments);
  }}[a];
}
function fc() {
  this.L = [void 0];
  this.cb = [];
}
var I = new fc(), gc = void 0;
function K(a) {
  throw new gc(a);
}
var hc = a => {
  a || K("Cannot use deleted val. handle = " + a);
  return I.get(a).value;
}, ic = a => {
  switch(a) {
    case void 0:
      return 1;
    case null:
      return 2;
    case !0:
      return 3;
    case !1:
      return 4;
    default:
      return I.ra({pb:1, value:a});
  }
};
function jc(a) {
  var b = Error, c = ec(a, function(d) {
    this.name = a;
    this.message = d;
    d = Error(d).stack;
    void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
  });
  c.prototype = Object.create(b.prototype);
  c.prototype.constructor = c;
  c.prototype.toString = function() {
    return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
  };
  return c;
}
var kc = void 0, lc = void 0;
function L(a) {
  for (var b = ""; x[a];) {
    b += lc[x[a++]];
  }
  return b;
}
var mc = [];
function nc() {
  for (; mc.length;) {
    var a = mc.pop();
    a.g.ga = !1;
    a["delete"]();
  }
}
var oc = void 0, pc = {};
function qc(a, b) {
  for (void 0 === b && K("ptr should not be undefined"); a.A;) {
    b = a.na(b), a = a.A;
  }
  return b;
}
var rc = {};
function sc(a) {
  a = tc(a);
  var b = L(a);
  uc(a);
  return b;
}
function vc(a, b) {
  var c = rc[a];
  void 0 === c && K(b + " has unknown type " + sc(a));
  return c;
}
function wc() {
}
var xc = !1;
function yc(a) {
  --a.count.value;
  0 === a.count.value && (a.G ? a.K.U(a.G) : a.u.i.U(a.o));
}
function zc(a, b, c) {
  if (b === c) {
    return a;
  }
  if (void 0 === c.A) {
    return null;
  }
  a = zc(a, b, c.A);
  return null === a ? null : c.Ib(a);
}
var Ac = {};
function Bc(a, b) {
  b = qc(a, b);
  return pc[b];
}
var Cc = void 0;
function Dc(a) {
  throw new Cc(a);
}
function Ec(a, b) {
  b.u && b.o || Dc("makeClassHandle requires ptr and ptrType");
  !!b.K !== !!b.G && Dc("Both smartPtrType and smartPtr must be specified");
  b.count = {value:1};
  return Fc(Object.create(a, {g:{value:b,},}));
}
function Fc(a) {
  if ("undefined" === typeof FinalizationRegistry) {
    return Fc = b => b, a;
  }
  xc = new FinalizationRegistry(b => {
    yc(b.g);
  });
  Fc = b => {
    var c = b.g;
    c.G && xc.register(b, {g:c}, b);
    return b;
  };
  wc = b => {
    xc.unregister(b);
  };
  return Fc(a);
}
var Gc = {};
function Hc(a) {
  for (; a.length;) {
    var b = a.pop();
    a.pop()(b);
  }
}
function Ic(a) {
  return this.fromWireType(D[a >> 2]);
}
var Jc = {}, Kc = {};
function N(a, b, c) {
  function d(k) {
    k = c(k);
    k.length !== a.length && Dc("Mismatched type converter count");
    for (var p = 0; p < a.length; ++p) {
      Lc(a[p], k[p]);
    }
  }
  a.forEach(function(k) {
    Kc[k] = b;
  });
  var e = Array(b.length), f = [], g = 0;
  b.forEach((k, p) => {
    rc.hasOwnProperty(k) ? e[p] = rc[k] : (f.push(k), Jc.hasOwnProperty(k) || (Jc[k] = []), Jc[k].push(() => {
      e[p] = rc[k];
      ++g;
      g === f.length && d(e);
    }));
  });
  0 === f.length && d(e);
}
function Mc(a) {
  switch(a) {
    case 1:
      return 0;
    case 2:
      return 1;
    case 4:
      return 2;
    case 8:
      return 3;
    default:
      throw new TypeError(`Unknown type size: ${a}`);
  }
}
function Nc(a, b, c = {}) {
  var d = b.name;
  a || K(`type "${d}" must have a positive integer typeid pointer`);
  if (rc.hasOwnProperty(a)) {
    if (c.Tb) {
      return;
    }
    K(`Cannot register type '${d}' twice`);
  }
  rc[a] = b;
  delete Kc[a];
  Jc.hasOwnProperty(a) && (b = Jc[a], delete Jc[a], b.forEach(e => e()));
}
function Lc(a, b, c = {}) {
  if (!("argPackAdvance" in b)) {
    throw new TypeError("registerType registeredInstance requires argPackAdvance");
  }
  Nc(a, b, c);
}
function Oc(a) {
  K(a.g.u.i.name + " instance already deleted");
}
function Pc() {
}
function Qc(a, b, c) {
  if (void 0 === a[b].B) {
    var d = a[b];
    a[b] = function() {
      a[b].B.hasOwnProperty(arguments.length) || K(`Function '${c}' called with an invalid number of arguments (${arguments.length}) - expects one of (${a[b].B})!`);
      return a[b].B[arguments.length].apply(this, arguments);
    };
    a[b].B = [];
    a[b].B[d.ea] = d;
  }
}
function Rc(a, b, c) {
  l.hasOwnProperty(a) ? ((void 0 === c || void 0 !== l[a].B && void 0 !== l[a].B[c]) && K(`Cannot register public name '${a}' twice`), Qc(l, a, a), l.hasOwnProperty(c) && K(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`), l[a].B[c] = b) : (l[a] = b, void 0 !== c && (l[a].Hc = c));
}
function Sc(a, b, c, d, e, f, g, k) {
  this.name = a;
  this.constructor = b;
  this.M = c;
  this.U = d;
  this.A = e;
  this.Nb = f;
  this.na = g;
  this.Ib = k;
  this.mb = [];
}
function Tc(a, b, c) {
  for (; b !== c;) {
    b.na || K(`Expected null or instance of ${c.name}, got an instance of ${b.name}`), a = b.na(a), b = b.A;
  }
  return a;
}
function Uc(a, b) {
  if (null === b) {
    return this.Na && K(`null is not a valid ${this.name}`), 0;
  }
  b.g || K(`Cannot pass "${Vc(b)}" as a ${this.name}`);
  b.g.o || K(`Cannot pass deleted object as a pointer of type ${this.name}`);
  return Tc(b.g.o, b.g.u.i, this.i);
}
function Wc(a, b) {
  if (null === b) {
    this.Na && K(`null is not a valid ${this.name}`);
    if (this.wa) {
      var c = this.Pa();
      null !== a && a.push(this.U, c);
      return c;
    }
    return 0;
  }
  b.g || K(`Cannot pass "${Vc(b)}" as a ${this.name}`);
  b.g.o || K(`Cannot pass deleted object as a pointer of type ${this.name}`);
  !this.va && b.g.u.va && K(`Cannot convert argument of type ${b.g.K ? b.g.K.name : b.g.u.name} to parameter type ${this.name}`);
  c = Tc(b.g.o, b.g.u.i, this.i);
  if (this.wa) {
    switch(void 0 === b.g.G && K("Passing raw pointer to smart pointer is illegal"), this.ic) {
      case 0:
        b.g.K === this ? c = b.g.G : K(`Cannot convert argument of type ${b.g.K ? b.g.K.name : b.g.u.name} to parameter type ${this.name}`);
        break;
      case 1:
        c = b.g.G;
        break;
      case 2:
        if (b.g.K === this) {
          c = b.g.G;
        } else {
          var d = b.clone();
          c = this.cc(c, ic(function() {
            d["delete"]();
          }));
          null !== a && a.push(this.U, c);
        }
        break;
      default:
        K("Unsupporting sharing policy");
    }
  }
  return c;
}
function Xc(a, b) {
  if (null === b) {
    return this.Na && K(`null is not a valid ${this.name}`), 0;
  }
  b.g || K(`Cannot pass "${Vc(b)}" as a ${this.name}`);
  b.g.o || K(`Cannot pass deleted object as a pointer of type ${this.name}`);
  b.g.u.va && K(`Cannot convert argument of type ${b.g.u.name} to parameter type ${this.name}`);
  return Tc(b.g.o, b.g.u.i, this.i);
}
function Yc(a, b, c, d) {
  this.name = a;
  this.i = b;
  this.Na = c;
  this.va = d;
  this.wa = !1;
  this.U = this.cc = this.Pa = this.nb = this.ic = this.bc = void 0;
  void 0 !== b.A ? this.toWireType = Wc : (this.toWireType = d ? Uc : Xc, this.J = null);
}
function Zc(a, b, c) {
  l.hasOwnProperty(a) || Dc("Replacing nonexistant public symbol");
  void 0 !== l[a].B && void 0 !== c ? l[a].B[c] = b : (l[a] = b, l[a].ea = c);
}
var $c = [], Q = a => {
  var b = $c[a];
  b || (a >= $c.length && ($c.length = a + 1), $c[a] = b = Ca.get(a));
  return b;
}, ad = (a, b) => {
  var c = [];
  return function() {
    c.length = 0;
    Object.assign(c, arguments);
    if (a.includes("j")) {
      var d = l["dynCall_" + a];
      d = c && c.length ? d.apply(null, [b].concat(c)) : d.call(null, b);
    } else {
      d = Q(b).apply(null, c);
    }
    return d;
  };
};
function R(a, b) {
  a = L(a);
  var c = a.includes("j") ? ad(a, b) : Q(b);
  "function" != typeof c && K(`unknown function pointer with signature ${a}: ${b}`);
  return c;
}
var bd = void 0;
function cd(a, b) {
  function c(f) {
    e[f] || rc[f] || (Kc[f] ? Kc[f].forEach(c) : (d.push(f), e[f] = !0));
  }
  var d = [], e = {};
  b.forEach(c);
  throw new bd(`${a}: ` + d.map(sc).join([", "]));
}
function dd(a, b, c, d, e) {
  var f = b.length;
  2 > f && K("argTypes array size mismatch! Must at least get return value and 'this' types!");
  var g = null !== b[1] && null !== c, k = !1;
  for (c = 1; c < b.length; ++c) {
    if (null !== b[c] && void 0 === b[c].J) {
      k = !0;
      break;
    }
  }
  var p = "void" !== b[0].name, n = f - 2, t = Array(n), w = [], y = [];
  return function() {
    arguments.length !== n && K(`function ${a} called with ${arguments.length} arguments, expected ${n} args!`);
    y.length = 0;
    w.length = g ? 2 : 1;
    w[0] = e;
    if (g) {
      var q = b[1].toWireType(y, this);
      w[1] = q;
    }
    for (var r = 0; r < n; ++r) {
      t[r] = b[r + 2].toWireType(y, arguments[r]), w.push(t[r]);
    }
    r = d.apply(null, w);
    if (k) {
      Hc(y);
    } else {
      for (var u = g ? 1 : 2; u < b.length; u++) {
        var z = 1 === u ? q : t[u - 2];
        null !== b[u].J && b[u].J(z);
      }
    }
    q = p ? b[0].fromWireType(r) : void 0;
    return q;
  };
}
function ed(a, b) {
  for (var c = [], d = 0; d < a; d++) {
    c.push(E[b + 4 * d >> 2]);
  }
  return c;
}
function fd(a, b, c) {
  a instanceof Object || K(`${c} with invalid "this": ${a}`);
  a instanceof b.i.constructor || K(`${c} incompatible with "this" of type ${a.constructor.name}`);
  a.g.o || K(`cannot call emscripten binding method ${c} on deleted object`);
  return Tc(a.g.o, a.g.u.i, b.i);
}
function gd(a) {
  a >= I.h && 0 === --I.get(a).pb && I.Sb(a);
}
function hd(a, b, c) {
  switch(b) {
    case 0:
      return function(d) {
        return this.fromWireType((c ? v : x)[d]);
      };
    case 1:
      return function(d) {
        return this.fromWireType((c ? A : za)[d >> 1]);
      };
    case 2:
      return function(d) {
        return this.fromWireType((c ? D : E)[d >> 2]);
      };
    default:
      throw new TypeError("Unknown integer type: " + a);
  }
}
function Vc(a) {
  if (null === a) {
    return "null";
  }
  var b = typeof a;
  return "object" === b || "array" === b || "function" === b ? a.toString() : "" + a;
}
function jd(a, b) {
  switch(b) {
    case 2:
      return function(c) {
        return this.fromWireType(F[c >> 2]);
      };
    case 3:
      return function(c) {
        return this.fromWireType(Aa[c >> 3]);
      };
    default:
      throw new TypeError("Unknown float type: " + a);
  }
}
function kd(a, b, c) {
  switch(b) {
    case 0:
      return c ? function(d) {
        return v[d];
      } : function(d) {
        return x[d];
      };
    case 1:
      return c ? function(d) {
        return A[d >> 1];
      } : function(d) {
        return za[d >> 1];
      };
    case 2:
      return c ? function(d) {
        return D[d >> 2];
      } : function(d) {
        return E[d >> 2];
      };
    default:
      throw new TypeError("Unknown integer type: " + a);
  }
}
var ld = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, md = (a, b) => {
  var c = a >> 1;
  for (var d = c + b / 2; !(c >= d) && za[c];) {
    ++c;
  }
  c <<= 1;
  if (32 < c - a && ld) {
    return ld.decode(x.subarray(a, c));
  }
  c = "";
  for (d = 0; !(d >= b / 2); ++d) {
    var e = A[a + 2 * d >> 1];
    if (0 == e) {
      break;
    }
    c += String.fromCharCode(e);
  }
  return c;
}, nd = (a, b, c) => {
  void 0 === c && (c = 2147483647);
  if (2 > c) {
    return 0;
  }
  c -= 2;
  var d = b;
  c = c < 2 * a.length ? c / 2 : a.length;
  for (var e = 0; e < c; ++e) {
    A[b >> 1] = a.charCodeAt(e), b += 2;
  }
  A[b >> 1] = 0;
  return b - d;
}, od = a => 2 * a.length, pd = (a, b) => {
  for (var c = 0, d = ""; !(c >= b / 4);) {
    var e = D[a + 4 * c >> 2];
    if (0 == e) {
      break;
    }
    ++c;
    65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
  }
  return d;
}, qd = (a, b, c) => {
  void 0 === c && (c = 2147483647);
  if (4 > c) {
    return 0;
  }
  var d = b;
  c = d + c - 4;
  for (var e = 0; e < a.length; ++e) {
    var f = a.charCodeAt(e);
    if (55296 <= f && 57343 >= f) {
      var g = a.charCodeAt(++e);
      f = 65536 + ((f & 1023) << 10) | g & 1023;
    }
    D[b >> 2] = f;
    b += 4;
    if (b + 4 > c) {
      break;
    }
  }
  D[b >> 2] = 0;
  return b - d;
}, rd = a => {
  for (var b = 0, c = 0; c < a.length; ++c) {
    var d = a.charCodeAt(c);
    55296 <= d && 57343 >= d && ++c;
    b += 4;
  }
  return b;
}, sd = {};
function td(a) {
  var b = sd[a];
  return void 0 === b ? L(a) : b;
}
var ud = [];
function vd(a) {
  var b = ud.length;
  ud.push(a);
  return b;
}
function wd(a, b) {
  for (var c = Array(a), d = 0; d < a; ++d) {
    c[d] = vc(E[b + 4 * d >> 2], "parameter " + d);
  }
  return c;
}
var xd = [], yd = [];
function zd(a) {
  var b = a.getExtension("ANGLE_instanced_arrays");
  b && (a.vertexAttribDivisor = function(c, d) {
    b.vertexAttribDivisorANGLE(c, d);
  }, a.drawArraysInstanced = function(c, d, e, f) {
    b.drawArraysInstancedANGLE(c, d, e, f);
  }, a.drawElementsInstanced = function(c, d, e, f, g) {
    b.drawElementsInstancedANGLE(c, d, e, f, g);
  });
}
function Ad(a) {
  var b = a.getExtension("OES_vertex_array_object");
  b && (a.createVertexArray = function() {
    return b.createVertexArrayOES();
  }, a.deleteVertexArray = function(c) {
    b.deleteVertexArrayOES(c);
  }, a.bindVertexArray = function(c) {
    b.bindVertexArrayOES(c);
  }, a.isVertexArray = function(c) {
    return b.isVertexArrayOES(c);
  });
}
function Bd(a) {
  var b = a.getExtension("WEBGL_draw_buffers");
  b && (a.drawBuffers = function(c, d) {
    b.drawBuffersWEBGL(c, d);
  });
}
var Cd = 1, Dd = [], Ed = [], Fd = [], Gd = [], Hd = [], Id = [], Jd = [], ia = [], Kd = [], Ld = [], Md = {}, Nd = {}, Od = 4;
function S(a) {
  Pd || (Pd = a);
}
function ha(a) {
  for (var b = Cd++, c = a.length; c < b; c++) {
    a[c] = null;
  }
  return b;
}
function la(a) {
  T = ia[a];
  l.yc = U = T && T.Ta;
  return !(a && !U);
}
function ka(a) {
  a || (a = T);
  if (!a.Ub) {
    a.Ub = !0;
    var b = a.Ta;
    zd(b);
    Ad(b);
    Bd(b);
    b.Ya = b.getExtension("WEBGL_draw_instanced_base_vertex_base_instance");
    b.gb = b.getExtension("WEBGL_multi_draw_instanced_base_vertex_base_instance");
    2 <= a.version && (b.Za = b.getExtension("EXT_disjoint_timer_query_webgl2"));
    if (2 > a.version || !b.Za) {
      b.Za = b.getExtension("EXT_disjoint_timer_query");
    }
    b.Fc = b.getExtension("WEBGL_multi_draw");
    (b.getSupportedExtensions() || []).forEach(function(c) {
      c.includes("lose_context") || c.includes("debug") || b.getExtension(c);
    });
  }
}
var Pd, T;
function Qd(a, b) {
  U.bindFramebuffer(a, Fd[b]);
}
function Rd(a) {
  U.bindVertexArray(Jd[a]);
}
function Sd(a, b) {
  for (var c = 0; c < a; c++) {
    var d = D[b + 4 * c >> 2];
    U.deleteVertexArray(Jd[d]);
    Jd[d] = null;
  }
}
var Td = [];
function Ud(a, b, c, d) {
  U.drawElements(a, b, c, d);
}
function Vd(a, b, c, d) {
  for (var e = 0; e < a; e++) {
    var f = U[c](), g = f && ha(d);
    f ? (f.name = g, d[g] = f) : S(1282);
    D[b + 4 * e >> 2] = g;
  }
}
function Wd(a, b) {
  Vd(a, b, "createVertexArray", Jd);
}
function Xd(a, b) {
  if (b) {
    var c = void 0;
    switch(a) {
      case 36346:
        c = 1;
        break;
      case 36344:
        return;
      case 34814:
      case 36345:
        c = 0;
        break;
      case 34466:
        var d = U.getParameter(34467);
        c = d ? d.length : 0;
        break;
      case 33309:
        if (2 > T.version) {
          S(1282);
          return;
        }
        c = 2 * (U.getSupportedExtensions() || []).length;
        break;
      case 33307:
      case 33308:
        if (2 > T.version) {
          S(1280);
          return;
        }
        c = 33307 == a ? 3 : 0;
    }
    if (void 0 === c) {
      switch(d = U.getParameter(a), typeof d) {
        case "number":
          c = d;
          break;
        case "boolean":
          c = d ? 1 : 0;
          break;
        case "string":
          S(1280);
          return;
        case "object":
          if (null === d) {
            switch(a) {
              case 34964:
              case 35725:
              case 34965:
              case 36006:
              case 36007:
              case 32873:
              case 34229:
              case 36662:
              case 36663:
              case 35053:
              case 35055:
              case 36010:
              case 35097:
              case 35869:
              case 32874:
              case 36389:
              case 35983:
              case 35368:
              case 34068:
                c = 0;
                break;
              default:
                S(1280);
                return;
            }
          } else {
            if (d instanceof Float32Array || d instanceof Uint32Array || d instanceof Int32Array || d instanceof Array) {
              for (a = 0; a < d.length; ++a) {
                D[b + 4 * a >> 2] = d[a];
              }
              return;
            }
            try {
              c = d.name | 0;
            } catch (e) {
              S(1280);
              ua("GL_INVALID_ENUM in glGet0v: Unknown object returned from WebGL getParameter(" + a + ")! (error: " + e + ")");
              return;
            }
          }
          break;
        default:
          S(1280);
          ua("GL_INVALID_ENUM in glGet0v: Native code calling glGet0v(" + a + ") and it returns " + d + " of type " + typeof d + "!");
          return;
      }
    }
    D[b >> 2] = c;
  } else {
    S(1281);
  }
}
function Yd(a, b) {
  Xd(a, b);
}
var $d = a => {
  var b = hb(a) + 1, c = Zd(b);
  c && ib(a, x, c, b);
  return c;
};
function ae(a) {
  return "]" == a.slice(-1) && a.lastIndexOf("[");
}
function be(a) {
  a -= 5120;
  return 0 == a ? v : 1 == a ? x : 2 == a ? A : 4 == a ? D : 6 == a ? F : 5 == a || 28922 == a || 28520 == a || 30779 == a || 30782 == a ? E : za;
}
function ce(a, b, c, d, e) {
  a = be(a);
  var f = 31 - Math.clz32(a.BYTES_PER_ELEMENT), g = Od;
  return a.subarray(e >> f, e + d * (c * ({5:3, 6:4, 8:2, 29502:3, 29504:4, 26917:2, 26918:2, 29846:3, 29847:4}[b - 6402] || 1) * (1 << f) + g - 1 & -g) >> f);
}
function V(a) {
  var b = U.Gb;
  if (b) {
    var c = b.ma[a];
    "number" == typeof c && (b.ma[a] = c = U.getUniformLocation(b, b.tb[a] + (0 < c ? "[" + c + "]" : "")));
    return c;
  }
  S(1282);
}
var de = [], ee = [], fe = {}, he = () => {
  if (!ge) {
    var a = {USER:"web_user", LOGNAME:"web_user", PATH:"/", PWD:"/", HOME:"/home/web_user", LANG:("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", _:na || "./this.program"}, b;
    for (b in fe) {
      void 0 === fe[b] ? delete a[b] : a[b] = fe[b];
    }
    var c = [];
    for (b in a) {
      c.push(`${b}=${a[b]}`);
    }
    ge = c;
  }
  return ge;
}, ge, ie = a => 0 === a % 4 && (0 !== a % 100 || 0 === a % 400), je = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], ke = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], le = (a, b, c, d) => {
  function e(q, r, u) {
    for (q = "number" == typeof q ? q.toString() : q || ""; q.length < r;) {
      q = u[0] + q;
    }
    return q;
  }
  function f(q, r) {
    return e(q, r, "0");
  }
  function g(q, r) {
    function u(B) {
      return 0 > B ? -1 : 0 < B ? 1 : 0;
    }
    var z;
    0 === (z = u(q.getFullYear() - r.getFullYear())) && 0 === (z = u(q.getMonth() - r.getMonth())) && (z = u(q.getDate() - r.getDate()));
    return z;
  }
  function k(q) {
    switch(q.getDay()) {
      case 0:
        return new Date(q.getFullYear() - 1, 11, 29);
      case 1:
        return q;
      case 2:
        return new Date(q.getFullYear(), 0, 3);
      case 3:
        return new Date(q.getFullYear(), 0, 2);
      case 4:
        return new Date(q.getFullYear(), 0, 1);
      case 5:
        return new Date(q.getFullYear() - 1, 11, 31);
      case 6:
        return new Date(q.getFullYear() - 1, 11, 30);
    }
  }
  function p(q) {
    var r = q.aa;
    for (q = new Date((new Date(q.ba + 1900, 0, 1)).getTime()); 0 < r;) {
      var u = q.getMonth(), z = (ie(q.getFullYear()) ? je : ke)[u];
      if (r > z - q.getDate()) {
        r -= z - q.getDate() + 1, q.setDate(1), 11 > u ? q.setMonth(u + 1) : (q.setMonth(0), q.setFullYear(q.getFullYear() + 1));
      } else {
        q.setDate(q.getDate() + r);
        break;
      }
    }
    u = new Date(q.getFullYear() + 1, 0, 4);
    r = k(new Date(q.getFullYear(), 0, 4));
    u = k(u);
    return 0 >= g(r, q) ? 0 >= g(u, q) ? q.getFullYear() + 1 : q.getFullYear() : q.getFullYear() - 1;
  }
  var n = D[d + 40 >> 2];
  d = {lc:D[d >> 2], kc:D[d + 4 >> 2], Ha:D[d + 8 >> 2], Ra:D[d + 12 >> 2], Ia:D[d + 16 >> 2], ba:D[d + 20 >> 2], P:D[d + 24 >> 2], aa:D[d + 28 >> 2], Jc:D[d + 32 >> 2], jc:D[d + 36 >> 2], mc:n ? n ? fb(x, n) : "" : ""};
  c = c ? fb(x, c) : "";
  n = {"%c":"%a %b %d %H:%M:%S %Y", "%D":"%m/%d/%y", "%F":"%Y-%m-%d", "%h":"%b", "%r":"%I:%M:%S %p", "%R":"%H:%M", "%T":"%H:%M:%S", "%x":"%m/%d/%y", "%X":"%H:%M:%S", "%Ec":"%c", "%EC":"%C", "%Ex":"%m/%d/%y", "%EX":"%H:%M:%S", "%Ey":"%y", "%EY":"%Y", "%Od":"%d", "%Oe":"%e", "%OH":"%H", "%OI":"%I", "%Om":"%m", "%OM":"%M", "%OS":"%S", "%Ou":"%u", "%OU":"%U", "%OV":"%V", "%Ow":"%w", "%OW":"%W", "%Oy":"%y",};
  for (var t in n) {
    c = c.replace(new RegExp(t, "g"), n[t]);
  }
  var w = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), y = "January February March April May June July August September October November December".split(" ");
  n = {"%a":q => w[q.P].substring(0, 3), "%A":q => w[q.P], "%b":q => y[q.Ia].substring(0, 3), "%B":q => y[q.Ia], "%C":q => f((q.ba + 1900) / 100 | 0, 2), "%d":q => f(q.Ra, 2), "%e":q => e(q.Ra, 2, " "), "%g":q => p(q).toString().substring(2), "%G":q => p(q), "%H":q => f(q.Ha, 2), "%I":q => {
    q = q.Ha;
    0 == q ? q = 12 : 12 < q && (q -= 12);
    return f(q, 2);
  }, "%j":q => {
    for (var r = 0, u = 0; u <= q.Ia - 1; r += (ie(q.ba + 1900) ? je : ke)[u++]) {
    }
    return f(q.Ra + r, 3);
  }, "%m":q => f(q.Ia + 1, 2), "%M":q => f(q.kc, 2), "%n":() => "\n", "%p":q => 0 <= q.Ha && 12 > q.Ha ? "AM" : "PM", "%S":q => f(q.lc, 2), "%t":() => "\t", "%u":q => q.P || 7, "%U":q => f(Math.floor((q.aa + 7 - q.P) / 7), 2), "%V":q => {
    var r = Math.floor((q.aa + 7 - (q.P + 6) % 7) / 7);
    2 >= (q.P + 371 - q.aa - 2) % 7 && r++;
    if (r) {
      53 == r && (u = (q.P + 371 - q.aa) % 7, 4 == u || 3 == u && ie(q.ba) || (r = 1));
    } else {
      r = 52;
      var u = (q.P + 7 - q.aa - 1) % 7;
      (4 == u || 5 == u && ie(q.ba % 400 - 1)) && r++;
    }
    return f(r, 2);
  }, "%w":q => q.P, "%W":q => f(Math.floor((q.aa + 7 - (q.P + 6) % 7) / 7), 2), "%y":q => (q.ba + 1900).toString().substring(2), "%Y":q => q.ba + 1900, "%z":q => {
    q = q.jc;
    var r = 0 <= q;
    q = Math.abs(q) / 60;
    return (r ? "+" : "-") + String("0000" + (q / 60 * 100 + q % 60)).slice(-4);
  }, "%Z":q => q.mc, "%%":() => "%"};
  c = c.replace(/%%/g, "\x00\x00");
  for (t in n) {
    c.includes(t) && (c = c.replace(new RegExp(t, "g"), n[t](d)));
  }
  c = c.replace(/\0\0/g, "%");
  t = jb(c, !1);
  if (t.length > b) {
    return 0;
  }
  v.set(t, a);
  return t.length - 1;
};
function Jb(a, b, c, d) {
  a || (a = this);
  this.parent = a;
  this.S = a.S;
  this.Ba = null;
  this.id = Ab++;
  this.name = b;
  this.mode = c;
  this.l = {};
  this.m = {};
  this.Da = d;
}
Object.defineProperties(Jb.prototype, {read:{get:function() {
  return 365 === (this.mode & 365);
}, set:function(a) {
  a ? this.mode |= 365 : this.mode &= -366;
}}, write:{get:function() {
  return 146 === (this.mode & 146);
}, set:function(a) {
  a ? this.mode |= 146 : this.mode &= -147;
}}});
Xb();
Bb = Array(4096);
Qb(H, "/");
Rb("/tmp", 16895, 0);
Rb("/home", 16895, 0);
Rb("/home/web_user", 16895, 0);
(() => {
  Rb("/dev", 16895, 0);
  mb(259, {read:() => 0, write:(d, e, f, g) => g,});
  Sb("/dev/null", 259);
  lb(1280, ob);
  lb(1536, pb);
  Sb("/dev/tty", 1280);
  Sb("/dev/tty1", 1536);
  var a = new Uint8Array(1024), b = 0, c = () => {
    0 === b && (b = cb(a).byteLength);
    return a[--b];
  };
  $b("random", c);
  $b("urandom", c);
  Rb("/dev/shm", 16895, 0);
  Rb("/dev/shm/tmp", 16895, 0);
})();
(() => {
  Rb("/proc", 16895, 0);
  var a = Rb("/proc/self", 16895, 0);
  Rb("/proc/self/fd", 16895, 0);
  Qb({S:() => {
    var b = sb(a, "fd", 16895, 73);
    b.l = {ka:(c, d) => {
      var e = Nb(+d);
      c = {parent:null, S:{ib:"fake"}, l:{la:() => e.path},};
      return c.parent = c;
    }};
    return b;
  }}, "/proc/self/fd");
})();
Object.assign(fc.prototype, {get(a) {
  return this.L[a];
}, has(a) {
  return void 0 !== this.L[a];
}, ra(a) {
  var b = this.cb.pop() || this.L.length;
  this.L[b] = a;
  return b;
}, Sb(a) {
  this.L[a] = void 0;
  this.cb.push(a);
}});
gc = l.BindingError = class extends Error {
  constructor(a) {
    super(a);
    this.name = "BindingError";
  }
};
I.L.push({value:void 0}, {value:null}, {value:!0}, {value:!1},);
I.h = I.L.length;
l.count_emval_handles = function() {
  for (var a = 0, b = I.h; b < I.L.length; ++b) {
    void 0 !== I.L[b] && ++a;
  }
  return a;
};
kc = l.PureVirtualError = jc("PureVirtualError");
for (var me = Array(256), ne = 0; 256 > ne; ++ne) {
  me[ne] = String.fromCharCode(ne);
}
lc = me;
l.getInheritedInstanceCount = function() {
  return Object.keys(pc).length;
};
l.getLiveInheritedInstances = function() {
  var a = [], b;
  for (b in pc) {
    pc.hasOwnProperty(b) && a.push(pc[b]);
  }
  return a;
};
l.flushPendingDeletes = nc;
l.setDelayFunction = function(a) {
  oc = a;
  mc.length && oc && oc(nc);
};
Cc = l.InternalError = class extends Error {
  constructor(a) {
    super(a);
    this.name = "InternalError";
  }
};
Pc.prototype.isAliasOf = function(a) {
  if (!(this instanceof Pc && a instanceof Pc)) {
    return !1;
  }
  var b = this.g.u.i, c = this.g.o, d = a.g.u.i;
  for (a = a.g.o; b.A;) {
    c = b.na(c), b = b.A;
  }
  for (; d.A;) {
    a = d.na(a), d = d.A;
  }
  return b === d && c === a;
};
Pc.prototype.clone = function() {
  this.g.o || Oc(this);
  if (this.g.ia) {
    return this.g.count.value += 1, this;
  }
  var a = Fc, b = Object, c = b.create, d = Object.getPrototypeOf(this), e = this.g;
  a = a(c.call(b, d, {g:{value:{count:e.count, ga:e.ga, ia:e.ia, o:e.o, u:e.u, G:e.G, K:e.K,},}}));
  a.g.count.value += 1;
  a.g.ga = !1;
  return a;
};
Pc.prototype["delete"] = function() {
  this.g.o || Oc(this);
  this.g.ga && !this.g.ia && K("Object already scheduled for deletion");
  wc(this);
  yc(this.g);
  this.g.ia || (this.g.G = void 0, this.g.o = void 0);
};
Pc.prototype.isDeleted = function() {
  return !this.g.o;
};
Pc.prototype.deleteLater = function() {
  this.g.o || Oc(this);
  this.g.ga && !this.g.ia && K("Object already scheduled for deletion");
  mc.push(this);
  1 === mc.length && oc && oc(nc);
  this.g.ga = !0;
  return this;
};
Yc.prototype.Ob = function(a) {
  this.nb && (a = this.nb(a));
  return a;
};
Yc.prototype.Xa = function(a) {
  this.U && this.U(a);
};
Yc.prototype.argPackAdvance = 8;
Yc.prototype.readValueFromPointer = Ic;
Yc.prototype.deleteObject = function(a) {
  if (null !== a) {
    a["delete"]();
  }
};
Yc.prototype.fromWireType = function(a) {
  function b() {
    return this.wa ? Ec(this.i.M, {u:this.bc, o:c, K:this, G:a,}) : Ec(this.i.M, {u:this, o:a,});
  }
  var c = this.Ob(a);
  if (!c) {
    return this.Xa(a), null;
  }
  var d = Bc(this.i, c);
  if (void 0 !== d) {
    if (0 === d.g.count.value) {
      return d.g.o = c, d.g.G = a, d.clone();
    }
    d = d.clone();
    this.Xa(a);
    return d;
  }
  d = this.i.Nb(c);
  d = Ac[d];
  if (!d) {
    return b.call(this);
  }
  d = this.va ? d.Fb : d.pointerType;
  var e = zc(c, this.i, d.i);
  return null === e ? b.call(this) : this.wa ? Ec(d.i.M, {u:d, o:e, K:this, G:a,}) : Ec(d.i.M, {u:d, o:e,});
};
bd = l.UnboundTypeError = jc("UnboundTypeError");
for (var U, W = 0; 32 > W; ++W) {
  Td.push(Array(W));
}
var oe = new Float32Array(288);
for (W = 0; 288 > W; ++W) {
  de[W] = oe.subarray(0, W + 1);
}
var pe = new Int32Array(288);
for (W = 0; 288 > W; ++W) {
  ee[W] = pe.subarray(0, W + 1);
}
var Ge = {__syscall_fcntl64:function(a, b, c) {
  bc = c;
  try {
    var d = Nb(a);
    switch(b) {
      case 0:
        var e = cc();
        return 0 > e ? -28 : Pb(d, e).V;
      case 1:
      case 2:
        return 0;
      case 3:
        return d.flags;
      case 4:
        return e = cc(), d.flags |= e, 0;
      case 5:
        return e = cc(), A[e + 0 >> 1] = 2, 0;
      case 6:
      case 7:
        return 0;
      case 16:
      case 8:
        return -28;
      case 9:
        return D[qe() >> 2] = 28, -1;
      default:
        return -28;
    }
  } catch (f) {
    if ("undefined" == typeof ac || "ErrnoError" !== f.name) {
      throw f;
    }
    return -f.Z;
  }
}, __syscall_ioctl:function(a, b, c) {
  bc = c;
  try {
    var d = Nb(a);
    switch(b) {
      case 21509:
        return d.s ? 0 : -59;
      case 21505:
        if (!d.s) {
          return -59;
        }
        if (d.s.T.Wb) {
          b = [3, 28, 127, 21, 4, 0, 1, 0, 17, 19, 26, 0, 18, 15, 23, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,];
          var e = cc();
          D[e >> 2] = 25856;
          D[e + 4 >> 2] = 5;
          D[e + 8 >> 2] = 191;
          D[e + 12 >> 2] = 35387;
          for (var f = 0; 32 > f; f++) {
            v[e + f + 17 >> 0] = b[f] || 0;
          }
        }
        return 0;
      case 21510:
      case 21511:
      case 21512:
        return d.s ? 0 : -59;
      case 21506:
      case 21507:
      case 21508:
        if (!d.s) {
          return -59;
        }
        if (d.s.T.Xb) {
          for (e = cc(), b = [], f = 0; 32 > f; f++) {
            b.push(v[e + f + 17 >> 0]);
          }
        }
        return 0;
      case 21519:
        if (!d.s) {
          return -59;
        }
        e = cc();
        return D[e >> 2] = 0;
      case 21520:
        return d.s ? -28 : -59;
      case 21531:
        e = cc();
        if (!d.m.Vb) {
          throw new G(59);
        }
        return d.m.Vb(d, b, e);
      case 21523:
        if (!d.s) {
          return -59;
        }
        d.s.T.Yb && (f = [24, 80], e = cc(), A[e >> 1] = f[0], A[e + 2 >> 1] = f[1]);
        return 0;
      case 21524:
        return d.s ? 0 : -59;
      case 21515:
        return d.s ? 0 : -59;
      default:
        return -28;
    }
  } catch (g) {
    if ("undefined" == typeof ac || "ErrnoError" !== g.name) {
      throw g;
    }
    return -g.Z;
  }
}, __syscall_openat:function(a, b, c, d) {
  bc = d;
  try {
    b = b ? fb(x, b) : "";
    var e = b;
    if ("/" === e.charAt(0)) {
      b = e;
    } else {
      var f = -100 === a ? "/" : Nb(a).path;
      if (0 == e.length) {
        throw new G(44);
      }
      b = Za(f + "/" + e);
    }
    var g = d ? cc() : 0;
    return Vb(b, c, g).V;
  } catch (k) {
    if ("undefined" == typeof ac || "ErrnoError" !== k.name) {
      throw k;
    }
    return -k.Z;
  }
}, _embind_create_inheriting_constructor:function(a, b, c) {
  a = L(a);
  b = vc(b, "wrapper");
  c = hc(c);
  var d = [].slice, e = b.i, f = e.M, g = e.A.M, k = e.A.constructor;
  a = ec(a, function() {
    e.A.mb.forEach(function(n) {
      if (this[n] === g[n]) {
        throw new kc(`Pure virtual function ${n} must be implemented in JavaScript`);
      }
    }.bind(this));
    Object.defineProperty(this, "__parent", {value:f});
    this.__construct.apply(this, d.call(arguments));
  });
  f.__construct = function() {
    this === f && K("Pass correct 'this' to __construct");
    var n = k.implement.apply(void 0, [this].concat(d.call(arguments)));
    wc(n);
    var t = n.g;
    n.notifyOnDestruction();
    t.ia = !0;
    Object.defineProperties(this, {g:{value:t}});
    Fc(this);
    n = t.o;
    n = qc(e, n);
    pc.hasOwnProperty(n) ? K(`Tried to register registered instance: ${n}`) : pc[n] = this;
  };
  f.__destruct = function() {
    this === f && K("Pass correct 'this' to __destruct");
    wc(this);
    var n = this.g.o;
    n = qc(e, n);
    pc.hasOwnProperty(n) ? delete pc[n] : K(`Tried to unregister unregistered instance: ${n}`);
  };
  a.prototype = Object.create(f);
  for (var p in c) {
    a.prototype[p] = c[p];
  }
  return ic(a);
}, _embind_finalize_value_object:function(a) {
  var b = Gc[a];
  delete Gc[a];
  var c = b.Pa, d = b.U, e = b.$a, f = e.map(g => g.Rb).concat(e.map(g => g.fc));
  N([a], f, g => {
    var k = {};
    e.forEach((p, n) => {
      var t = g[n], w = p.Pb, y = p.Qb, q = g[n + e.length], r = p.ec, u = p.hc;
      k[p.Lb] = {read:z => t.fromWireType(w(y, z)), write:(z, B) => {
        var C = [];
        r(u, z, q.toWireType(C, B));
        Hc(C);
      }};
    });
    return [{name:b.name, fromWireType:function(p) {
      var n = {}, t;
      for (t in k) {
        n[t] = k[t].read(p);
      }
      d(p);
      return n;
    }, toWireType:function(p, n) {
      for (var t in k) {
        if (!(t in n)) {
          throw new TypeError(`Missing field: "${t}"`);
        }
      }
      var w = c();
      for (t in k) {
        k[t].write(w, n[t]);
      }
      null !== p && p.push(d, w);
      return w;
    }, argPackAdvance:8, readValueFromPointer:Ic, J:d,}];
  });
}, _embind_register_bigint:function() {
}, _embind_register_bool:function(a, b, c, d, e) {
  var f = Mc(c);
  b = L(b);
  Lc(a, {name:b, fromWireType:function(g) {
    return !!g;
  }, toWireType:function(g, k) {
    return k ? d : e;
  }, argPackAdvance:8, readValueFromPointer:function(g) {
    if (1 === c) {
      var k = v;
    } else if (2 === c) {
      k = A;
    } else if (4 === c) {
      k = D;
    } else {
      throw new TypeError("Unknown boolean type size: " + b);
    }
    return this.fromWireType(k[g >> f]);
  }, J:null,});
}, _embind_register_class:function(a, b, c, d, e, f, g, k, p, n, t, w, y) {
  t = L(t);
  f = R(e, f);
  k && (k = R(g, k));
  n && (n = R(p, n));
  y = R(w, y);
  var q = dc(t);
  Rc(q, function() {
    cd(`Cannot construct ${t} due to unbound types`, [d]);
  });
  N([a, b, c], d ? [d] : [], function(r) {
    r = r[0];
    if (d) {
      var u = r.i;
      var z = u.M;
    } else {
      z = Pc.prototype;
    }
    r = ec(q, function() {
      if (Object.getPrototypeOf(this) !== B) {
        throw new gc("Use 'new' to construct " + t);
      }
      if (void 0 === C.Y) {
        throw new gc(t + " has no accessible constructor");
      }
      var M = C.Y[arguments.length];
      if (void 0 === M) {
        throw new gc(`Tried to invoke ctor of ${t} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(C.Y).toString()}) parameters instead!`);
      }
      return M.apply(this, arguments);
    });
    var B = Object.create(z, {constructor:{value:r},});
    r.prototype = B;
    var C = new Sc(t, r, B, y, u, f, k, n);
    C.A && (void 0 === C.A.oa && (C.A.oa = []), C.A.oa.push(C));
    u = new Yc(t, C, !0, !1);
    z = new Yc(t + "*", C, !1, !1);
    var O = new Yc(t + " const*", C, !1, !0);
    Ac[a] = {pointerType:z, Fb:O};
    Zc(q, r);
    return [u, z, O];
  });
}, _embind_register_class_class_function:function(a, b, c, d, e, f, g) {
  var k = ed(c, d);
  b = L(b);
  f = R(e, f);
  N([], [a], function(p) {
    function n() {
      cd(`Cannot call ${t} due to unbound types`, k);
    }
    p = p[0];
    var t = `${p.name}.${b}`;
    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
    var w = p.i.constructor;
    void 0 === w[b] ? (n.ea = c - 1, w[b] = n) : (Qc(w, b, t), w[b].B[c - 1] = n);
    N([], k, function(y) {
      y = dd(t, [y[0], null].concat(y.slice(1)), null, f, g);
      void 0 === w[b].B ? (y.ea = c - 1, w[b] = y) : w[b].B[c - 1] = y;
      if (p.i.oa) {
        for (const q of p.i.oa) {
          q.constructor.hasOwnProperty(b) || (q.constructor[b] = y);
        }
      }
      return [];
    });
    return [];
  });
}, _embind_register_class_class_property:function(a, b, c, d, e, f, g, k) {
  b = L(b);
  f = R(e, f);
  N([], [a], function(p) {
    p = p[0];
    var n = `${p.name}.${b}`, t = {get() {
      cd(`Cannot access ${n} due to unbound types`, [c]);
    }, enumerable:!0, configurable:!0};
    t.set = k ? () => {
      cd(`Cannot access ${n} due to unbound types`, [c]);
    } : () => {
      K(`${n} is a read-only property`);
    };
    Object.defineProperty(p.i.constructor, b, t);
    N([], [c], function(w) {
      w = w[0];
      var y = {get() {
        return w.fromWireType(f(d));
      }, enumerable:!0};
      k && (k = R(g, k), y.set = q => {
        var r = [];
        k(d, w.toWireType(r, q));
        Hc(r);
      });
      Object.defineProperty(p.i.constructor, b, y);
      return [];
    });
    return [];
  });
}, _embind_register_class_constructor:function(a, b, c, d, e, f) {
  var g = ed(b, c);
  e = R(d, e);
  N([], [a], function(k) {
    k = k[0];
    var p = `constructor ${k.name}`;
    void 0 === k.i.Y && (k.i.Y = []);
    if (void 0 !== k.i.Y[b - 1]) {
      throw new gc(`Cannot register multiple constructors with identical number of parameters (${b - 1}) for class '${k.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
    }
    k.i.Y[b - 1] = () => {
      cd(`Cannot construct ${k.name} due to unbound types`, g);
    };
    N([], g, function(n) {
      n.splice(1, 0, null);
      k.i.Y[b - 1] = dd(p, n, null, e, f);
      return [];
    });
    return [];
  });
}, _embind_register_class_function:function(a, b, c, d, e, f, g, k) {
  var p = ed(c, d);
  b = L(b);
  f = R(e, f);
  N([], [a], function(n) {
    function t() {
      cd(`Cannot call ${w} due to unbound types`, p);
    }
    n = n[0];
    var w = `${n.name}.${b}`;
    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
    k && n.i.mb.push(b);
    var y = n.i.M, q = y[b];
    void 0 === q || void 0 === q.B && q.className !== n.name && q.ea === c - 2 ? (t.ea = c - 2, t.className = n.name, y[b] = t) : (Qc(y, b, w), y[b].B[c - 2] = t);
    N([], p, function(r) {
      r = dd(w, r, n, f, g);
      void 0 === y[b].B ? (r.ea = c - 2, y[b] = r) : y[b].B[c - 2] = r;
      return [];
    });
    return [];
  });
}, _embind_register_class_property:function(a, b, c, d, e, f, g, k, p, n) {
  b = L(b);
  e = R(d, e);
  N([], [a], function(t) {
    t = t[0];
    var w = `${t.name}.${b}`, y = {get() {
      cd(`Cannot access ${w} due to unbound types`, [c, g]);
    }, enumerable:!0, configurable:!0};
    y.set = p ? () => {
      cd(`Cannot access ${w} due to unbound types`, [c, g]);
    } : () => {
      K(w + " is a read-only property");
    };
    Object.defineProperty(t.i.M, b, y);
    N([], p ? [c, g] : [c], function(q) {
      var r = q[0], u = {get() {
        var B = fd(this, t, w + " getter");
        return r.fromWireType(e(f, B));
      }, enumerable:!0};
      if (p) {
        p = R(k, p);
        var z = q[1];
        u.set = function(B) {
          var C = fd(this, t, w + " setter"), O = [];
          p(n, C, z.toWireType(O, B));
          Hc(O);
        };
      }
      Object.defineProperty(t.i.M, b, u);
      return [];
    });
    return [];
  });
}, _embind_register_emval:function(a, b) {
  b = L(b);
  Lc(a, {name:b, fromWireType:function(c) {
    var d = hc(c);
    gd(c);
    return d;
  }, toWireType:function(c, d) {
    return ic(d);
  }, argPackAdvance:8, readValueFromPointer:Ic, J:null,});
}, _embind_register_enum:function(a, b, c, d) {
  function e() {
  }
  c = Mc(c);
  b = L(b);
  e.values = {};
  Lc(a, {name:b, constructor:e, fromWireType:function(f) {
    return this.constructor.values[f];
  }, toWireType:function(f, g) {
    return g.value;
  }, argPackAdvance:8, readValueFromPointer:hd(b, c, d), J:null,});
  Rc(b, e);
}, _embind_register_enum_value:function(a, b, c) {
  var d = vc(a, "enum");
  b = L(b);
  a = d.constructor;
  d = Object.create(d.constructor.prototype, {value:{value:c}, constructor:{value:ec(`${d.name}_${b}`, function() {
  })},});
  a.values[c] = d;
  a[b] = d;
}, _embind_register_float:function(a, b, c) {
  c = Mc(c);
  b = L(b);
  Lc(a, {name:b, fromWireType:function(d) {
    return d;
  }, toWireType:function(d, e) {
    return e;
  }, argPackAdvance:8, readValueFromPointer:jd(b, c), J:null,});
}, _embind_register_function:function(a, b, c, d, e, f) {
  var g = ed(b, c);
  a = L(a);
  e = R(d, e);
  Rc(a, function() {
    cd(`Cannot call ${a} due to unbound types`, g);
  }, b - 1);
  N([], g, function(k) {
    Zc(a, dd(a, [k[0], null].concat(k.slice(1)), null, e, f), b - 1);
    return [];
  });
}, _embind_register_integer:function(a, b, c, d, e) {
  b = L(b);
  -1 === e && (e = 4294967295);
  e = Mc(c);
  var f = k => k;
  if (0 === d) {
    var g = 32 - 8 * c;
    f = k => k << g >>> g;
  }
  c = b.includes("unsigned") ? function(k, p) {
    return p >>> 0;
  } : function(k, p) {
    return p;
  };
  Lc(a, {name:b, fromWireType:f, toWireType:c, argPackAdvance:8, readValueFromPointer:kd(b, e, 0 !== d), J:null,});
}, _embind_register_memory_view:function(a, b, c) {
  function d(f) {
    f >>= 2;
    var g = E;
    return new e(g.buffer, g[f + 1], g[f]);
  }
  var e = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array,][b];
  c = L(c);
  Lc(a, {name:c, fromWireType:d, argPackAdvance:8, readValueFromPointer:d,}, {Tb:!0,});
}, _embind_register_std_string:function(a, b) {
  b = L(b);
  var c = "std::string" === b;
  Lc(a, {name:b, fromWireType:function(d) {
    var e = E[d >> 2], f = d + 4;
    if (c) {
      for (var g = f, k = 0; k <= e; ++k) {
        var p = f + k;
        if (k == e || 0 == x[p]) {
          g = g ? fb(x, g, p - g) : "";
          if (void 0 === n) {
            var n = g;
          } else {
            n += String.fromCharCode(0), n += g;
          }
          g = p + 1;
        }
      }
    } else {
      n = Array(e);
      for (k = 0; k < e; ++k) {
        n[k] = String.fromCharCode(x[f + k]);
      }
      n = n.join("");
    }
    uc(d);
    return n;
  }, toWireType:function(d, e) {
    e instanceof ArrayBuffer && (e = new Uint8Array(e));
    var f = "string" == typeof e;
    f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array || K("Cannot pass non-string to std::string");
    var g = c && f ? hb(e) : e.length;
    var k = Zd(4 + g + 1), p = k + 4;
    E[k >> 2] = g;
    if (c && f) {
      ib(e, x, p, g + 1);
    } else {
      if (f) {
        for (f = 0; f < g; ++f) {
          var n = e.charCodeAt(f);
          255 < n && (uc(p), K("String has UTF-16 code units that do not fit in 8 bits"));
          x[p + f] = n;
        }
      } else {
        for (f = 0; f < g; ++f) {
          x[p + f] = e[f];
        }
      }
    }
    null !== d && d.push(uc, k);
    return k;
  }, argPackAdvance:8, readValueFromPointer:Ic, J:function(d) {
    uc(d);
  },});
}, _embind_register_std_wstring:function(a, b, c) {
  c = L(c);
  if (2 === b) {
    var d = md;
    var e = nd;
    var f = od;
    var g = () => za;
    var k = 1;
  } else {
    4 === b && (d = pd, e = qd, f = rd, g = () => E, k = 2);
  }
  Lc(a, {name:c, fromWireType:function(p) {
    for (var n = E[p >> 2], t = g(), w, y = p + 4, q = 0; q <= n; ++q) {
      var r = p + 4 + q * b;
      if (q == n || 0 == t[r >> k]) {
        y = d(y, r - y), void 0 === w ? w = y : (w += String.fromCharCode(0), w += y), y = r + b;
      }
    }
    uc(p);
    return w;
  }, toWireType:function(p, n) {
    "string" != typeof n && K(`Cannot pass non-string to C++ string type ${c}`);
    var t = f(n), w = Zd(4 + t + b);
    E[w >> 2] = t >> k;
    e(n, w + 4, t + b);
    null !== p && p.push(uc, w);
    return w;
  }, argPackAdvance:8, readValueFromPointer:Ic, J:function(p) {
    uc(p);
  },});
}, _embind_register_value_object:function(a, b, c, d, e, f) {
  Gc[a] = {name:L(b), Pa:R(c, d), U:R(e, f), $a:[],};
}, _embind_register_value_object_field:function(a, b, c, d, e, f, g, k, p, n) {
  Gc[a].$a.push({Lb:L(b), Rb:c, Pb:R(d, e), Qb:f, fc:g, ec:R(k, p), hc:n,});
}, _embind_register_void:function(a, b) {
  b = L(b);
  Lc(a, {Zb:!0, name:b, argPackAdvance:0, fromWireType:function() {
  }, toWireType:function() {
  },});
}, _emscripten_get_now_is_monotonic:() => !0, _emscripten_throw_longjmp:() => {
  throw Infinity;
}, _emval_as:function(a, b, c) {
  a = hc(a);
  b = vc(b, "emval::as");
  var d = [], e = ic(d);
  E[c >> 2] = e;
  return b.toWireType(d, a);
}, _emval_call_method:function(a, b, c, d, e) {
  a = ud[a];
  b = hc(b);
  c = td(c);
  var f = [];
  E[d >> 2] = ic(f);
  return a(b, c, f, e);
}, _emval_call_void_method:function(a, b, c, d) {
  a = ud[a];
  b = hc(b);
  c = td(c);
  a(b, c, null, d);
}, _emval_decref:gd, _emval_get_method_caller:function(a, b) {
  var c = wd(a, b), d = c[0];
  b = d.name + "_$" + c.slice(1).map(function(g) {
    return g.name;
  }).join("_") + "$";
  var e = xd[b];
  if (void 0 !== e) {
    return e;
  }
  var f = Array(a - 1);
  e = vd((g, k, p, n) => {
    for (var t = 0, w = 0; w < a - 1; ++w) {
      f[w] = c[w + 1].readValueFromPointer(n + t), t += c[w + 1].argPackAdvance;
    }
    g = g[k].apply(g, f);
    for (w = 0; w < a - 1; ++w) {
      c[w + 1].Hb && c[w + 1].Hb(f[w]);
    }
    if (!d.Zb) {
      return d.toWireType(p, g);
    }
  });
  return xd[b] = e;
}, _emval_get_property:function(a, b) {
  a = hc(a);
  b = hc(b);
  return ic(a[b]);
}, _emval_incref:function(a) {
  4 < a && (I.get(a).pb += 1);
}, _emval_new_array:function() {
  return ic([]);
}, _emval_new_cstring:function(a) {
  return ic(td(a));
}, _emval_new_object:function() {
  return ic({});
}, _emval_run_destructors:function(a) {
  var b = hc(a);
  Hc(b);
  gd(a);
}, _emval_set_property:function(a, b, c) {
  a = hc(a);
  b = hc(b);
  c = hc(c);
  a[b] = c;
}, _emval_take_value:function(a, b) {
  a = vc(a, "_emval_take_value");
  a = a.readValueFromPointer(b);
  return ic(a);
}, abort:() => {
  wa("");
}, emscripten_asm_const_int:(a, b, c) => {
  yd.length = 0;
  var d;
  for (c >>= 2; d = x[b++];) {
    c += 105 != d & c, yd.push(105 == d ? D[c] : Aa[c++ >> 1]), ++c;
  }
  return Wa[a].apply(null, yd);
}, emscripten_date_now:function() {
  return Date.now();
}, emscripten_get_now:() => performance.now(), emscripten_glActiveTexture:function(a) {
  U.activeTexture(a);
}, emscripten_glAttachShader:function(a, b) {
  U.attachShader(Ed[a], Id[b]);
}, emscripten_glBindAttribLocation:function(a, b, c) {
  U.bindAttribLocation(Ed[a], b, c ? fb(x, c) : "");
}, emscripten_glBindBuffer:function(a, b) {
  35051 == a ? U.Ka = b : 35052 == a && (U.fa = b);
  U.bindBuffer(a, Dd[b]);
}, emscripten_glBindFramebuffer:Qd, emscripten_glBindRenderbuffer:function(a, b) {
  U.bindRenderbuffer(a, Gd[b]);
}, emscripten_glBindSampler:function(a, b) {
  U.bindSampler(a, Kd[b]);
}, emscripten_glBindTexture:function(a, b) {
  U.bindTexture(a, Hd[b]);
}, emscripten_glBindVertexArray:Rd, emscripten_glBindVertexArrayOES:Rd, emscripten_glBlendColor:function(a, b, c, d) {
  U.blendColor(a, b, c, d);
}, emscripten_glBlendEquation:function(a) {
  U.blendEquation(a);
}, emscripten_glBlendFunc:function(a, b) {
  U.blendFunc(a, b);
}, emscripten_glBlitFramebuffer:function(a, b, c, d, e, f, g, k, p, n) {
  U.blitFramebuffer(a, b, c, d, e, f, g, k, p, n);
}, emscripten_glBufferData:function(a, b, c, d) {
  2 <= T.version ? c && b ? U.bufferData(a, x, d, c, b) : U.bufferData(a, b, d) : U.bufferData(a, c ? x.subarray(c, c + b) : b, d);
}, emscripten_glBufferSubData:function(a, b, c, d) {
  2 <= T.version ? c && U.bufferSubData(a, b, x, d, c) : U.bufferSubData(a, b, x.subarray(d, d + c));
}, emscripten_glCheckFramebufferStatus:function(a) {
  return U.checkFramebufferStatus(a);
}, emscripten_glClear:function(a) {
  U.clear(a);
}, emscripten_glClearColor:function(a, b, c, d) {
  U.clearColor(a, b, c, d);
}, emscripten_glClearStencil:function(a) {
  U.clearStencil(a);
}, emscripten_glClientWaitSync:function(a, b, c, d) {
  return U.clientWaitSync(Ld[a], b, (c >>> 0) + 4294967296 * d);
}, emscripten_glColorMask:function(a, b, c, d) {
  U.colorMask(!!a, !!b, !!c, !!d);
}, emscripten_glCompileShader:function(a) {
  U.compileShader(Id[a]);
}, emscripten_glCompressedTexImage2D:function(a, b, c, d, e, f, g, k) {
  2 <= T.version ? U.fa || !g ? U.compressedTexImage2D(a, b, c, d, e, f, g, k) : U.compressedTexImage2D(a, b, c, d, e, f, x, k, g) : U.compressedTexImage2D(a, b, c, d, e, f, k ? x.subarray(k, k + g) : null);
}, emscripten_glCompressedTexSubImage2D:function(a, b, c, d, e, f, g, k, p) {
  2 <= T.version ? U.fa || !k ? U.compressedTexSubImage2D(a, b, c, d, e, f, g, k, p) : U.compressedTexSubImage2D(a, b, c, d, e, f, g, x, p, k) : U.compressedTexSubImage2D(a, b, c, d, e, f, g, p ? x.subarray(p, p + k) : null);
}, emscripten_glCopyTexSubImage2D:function(a, b, c, d, e, f, g, k) {
  U.copyTexSubImage2D(a, b, c, d, e, f, g, k);
}, emscripten_glCreateProgram:function() {
  var a = ha(Ed), b = U.createProgram();
  b.name = a;
  b.za = b.xa = b.ya = 0;
  b.Sa = 1;
  Ed[a] = b;
  return a;
}, emscripten_glCreateShader:function(a) {
  var b = ha(Id);
  Id[b] = U.createShader(a);
  return b;
}, emscripten_glCullFace:function(a) {
  U.cullFace(a);
}, emscripten_glDeleteBuffers:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = D[b + 4 * c >> 2], e = Dd[d];
    e && (U.deleteBuffer(e), e.name = 0, Dd[d] = null, d == U.Ka && (U.Ka = 0), d == U.fa && (U.fa = 0));
  }
}, emscripten_glDeleteFramebuffers:function(a, b) {
  for (var c = 0; c < a; ++c) {
    var d = D[b + 4 * c >> 2], e = Fd[d];
    e && (U.deleteFramebuffer(e), e.name = 0, Fd[d] = null);
  }
}, emscripten_glDeleteProgram:function(a) {
  if (a) {
    var b = Ed[a];
    b ? (U.deleteProgram(b), b.name = 0, Ed[a] = null) : S(1281);
  }
}, emscripten_glDeleteRenderbuffers:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = D[b + 4 * c >> 2], e = Gd[d];
    e && (U.deleteRenderbuffer(e), e.name = 0, Gd[d] = null);
  }
}, emscripten_glDeleteSamplers:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = D[b + 4 * c >> 2], e = Kd[d];
    e && (U.deleteSampler(e), e.name = 0, Kd[d] = null);
  }
}, emscripten_glDeleteShader:function(a) {
  if (a) {
    var b = Id[a];
    b ? (U.deleteShader(b), Id[a] = null) : S(1281);
  }
}, emscripten_glDeleteSync:function(a) {
  if (a) {
    var b = Ld[a];
    b ? (U.deleteSync(b), b.name = 0, Ld[a] = null) : S(1281);
  }
}, emscripten_glDeleteTextures:function(a, b) {
  for (var c = 0; c < a; c++) {
    var d = D[b + 4 * c >> 2], e = Hd[d];
    e && (U.deleteTexture(e), e.name = 0, Hd[d] = null);
  }
}, emscripten_glDeleteVertexArrays:Sd, emscripten_glDeleteVertexArraysOES:Sd, emscripten_glDepthMask:function(a) {
  U.depthMask(!!a);
}, emscripten_glDisable:function(a) {
  U.disable(a);
}, emscripten_glDisableVertexAttribArray:function(a) {
  U.disableVertexAttribArray(a);
}, emscripten_glDrawArrays:function(a, b, c) {
  U.drawArrays(a, b, c);
}, emscripten_glDrawArraysInstanced:function(a, b, c, d) {
  U.drawArraysInstanced(a, b, c, d);
}, emscripten_glDrawArraysInstancedBaseInstanceWEBGL:function(a, b, c, d, e) {
  U.Ya.drawArraysInstancedBaseInstanceWEBGL(a, b, c, d, e);
}, emscripten_glDrawBuffers:function(a, b) {
  for (var c = Td[a], d = 0; d < a; d++) {
    c[d] = D[b + 4 * d >> 2];
  }
  U.drawBuffers(c);
}, emscripten_glDrawElements:Ud, emscripten_glDrawElementsInstanced:function(a, b, c, d, e) {
  U.drawElementsInstanced(a, b, c, d, e);
}, emscripten_glDrawElementsInstancedBaseVertexBaseInstanceWEBGL:function(a, b, c, d, e, f, g) {
  U.Ya.drawElementsInstancedBaseVertexBaseInstanceWEBGL(a, b, c, d, e, f, g);
}, emscripten_glDrawRangeElements:function(a, b, c, d, e, f) {
  Ud(a, d, e, f);
}, emscripten_glEnable:function(a) {
  U.enable(a);
}, emscripten_glEnableVertexAttribArray:function(a) {
  U.enableVertexAttribArray(a);
}, emscripten_glFenceSync:function(a, b) {
  return (a = U.fenceSync(a, b)) ? (b = ha(Ld), a.name = b, Ld[b] = a, b) : 0;
}, emscripten_glFinish:function() {
  U.finish();
}, emscripten_glFlush:function() {
  U.flush();
}, emscripten_glFramebufferRenderbuffer:function(a, b, c, d) {
  U.framebufferRenderbuffer(a, b, c, Gd[d]);
}, emscripten_glFramebufferTexture2D:function(a, b, c, d, e) {
  U.framebufferTexture2D(a, b, c, Hd[d], e);
}, emscripten_glFrontFace:function(a) {
  U.frontFace(a);
}, emscripten_glGenBuffers:function(a, b) {
  Vd(a, b, "createBuffer", Dd);
}, emscripten_glGenFramebuffers:function(a, b) {
  Vd(a, b, "createFramebuffer", Fd);
}, emscripten_glGenRenderbuffers:function(a, b) {
  Vd(a, b, "createRenderbuffer", Gd);
}, emscripten_glGenSamplers:function(a, b) {
  Vd(a, b, "createSampler", Kd);
}, emscripten_glGenTextures:function(a, b) {
  Vd(a, b, "createTexture", Hd);
}, emscripten_glGenVertexArrays:Wd, emscripten_glGenVertexArraysOES:Wd, emscripten_glGenerateMipmap:function(a) {
  U.generateMipmap(a);
}, emscripten_glGetBufferParameteriv:function(a, b, c) {
  c ? D[c >> 2] = U.getBufferParameter(a, b) : S(1281);
}, emscripten_glGetError:function() {
  var a = U.getError() || Pd;
  Pd = 0;
  return a;
}, emscripten_glGetFramebufferAttachmentParameteriv:function(a, b, c, d) {
  a = U.getFramebufferAttachmentParameter(a, b, c);
  if (a instanceof WebGLRenderbuffer || a instanceof WebGLTexture) {
    a = a.name | 0;
  }
  D[d >> 2] = a;
}, emscripten_glGetIntegerv:Yd, emscripten_glGetProgramInfoLog:function(a, b, c, d) {
  a = U.getProgramInfoLog(Ed[a]);
  null === a && (a = "(unknown error)");
  b = 0 < b && d ? ib(a, x, d, b) : 0;
  c && (D[c >> 2] = b);
}, emscripten_glGetProgramiv:function(a, b, c) {
  if (c) {
    if (a >= Cd) {
      S(1281);
    } else {
      if (a = Ed[a], 35716 == b) {
        a = U.getProgramInfoLog(a), null === a && (a = "(unknown error)"), D[c >> 2] = a.length + 1;
      } else if (35719 == b) {
        if (!a.za) {
          for (b = 0; b < U.getProgramParameter(a, 35718); ++b) {
            a.za = Math.max(a.za, U.getActiveUniform(a, b).name.length + 1);
          }
        }
        D[c >> 2] = a.za;
      } else if (35722 == b) {
        if (!a.xa) {
          for (b = 0; b < U.getProgramParameter(a, 35721); ++b) {
            a.xa = Math.max(a.xa, U.getActiveAttrib(a, b).name.length + 1);
          }
        }
        D[c >> 2] = a.xa;
      } else if (35381 == b) {
        if (!a.ya) {
          for (b = 0; b < U.getProgramParameter(a, 35382); ++b) {
            a.ya = Math.max(a.ya, U.getActiveUniformBlockName(a, b).length + 1);
          }
        }
        D[c >> 2] = a.ya;
      } else {
        D[c >> 2] = U.getProgramParameter(a, b);
      }
    }
  } else {
    S(1281);
  }
}, emscripten_glGetRenderbufferParameteriv:function(a, b, c) {
  c ? D[c >> 2] = U.getRenderbufferParameter(a, b) : S(1281);
}, emscripten_glGetShaderInfoLog:function(a, b, c, d) {
  a = U.getShaderInfoLog(Id[a]);
  null === a && (a = "(unknown error)");
  b = 0 < b && d ? ib(a, x, d, b) : 0;
  c && (D[c >> 2] = b);
}, emscripten_glGetShaderPrecisionFormat:function(a, b, c, d) {
  a = U.getShaderPrecisionFormat(a, b);
  D[c >> 2] = a.rangeMin;
  D[c + 4 >> 2] = a.rangeMax;
  D[d >> 2] = a.precision;
}, emscripten_glGetShaderiv:function(a, b, c) {
  c ? 35716 == b ? (a = U.getShaderInfoLog(Id[a]), null === a && (a = "(unknown error)"), D[c >> 2] = a ? a.length + 1 : 0) : 35720 == b ? (a = U.getShaderSource(Id[a]), D[c >> 2] = a ? a.length + 1 : 0) : D[c >> 2] = U.getShaderParameter(Id[a], b) : S(1281);
}, emscripten_glGetString:function(a) {
  var b = Md[a];
  if (!b) {
    switch(a) {
      case 7939:
        b = U.getSupportedExtensions() || [];
        b = b.concat(b.map(function(d) {
          return "GL_" + d;
        }));
        b = $d(b.join(" "));
        break;
      case 7936:
      case 7937:
      case 37445:
      case 37446:
        (b = U.getParameter(a)) || S(1280);
        b = b && $d(b);
        break;
      case 7938:
        b = U.getParameter(7938);
        b = 2 <= T.version ? "OpenGL ES 3.0 (" + b + ")" : "OpenGL ES 2.0 (" + b + ")";
        b = $d(b);
        break;
      case 35724:
        b = U.getParameter(35724);
        var c = b.match(/^WebGL GLSL ES ([0-9]\.[0-9][0-9]?)(?:$| .*)/);
        null !== c && (3 == c[1].length && (c[1] += "0"), b = "OpenGL ES GLSL ES " + c[1] + " (" + b + ")");
        b = $d(b);
        break;
      default:
        S(1280);
    }
    Md[a] = b;
  }
  return b;
}, emscripten_glGetStringi:function(a, b) {
  if (2 > T.version) {
    return S(1282), 0;
  }
  var c = Nd[a];
  if (c) {
    return 0 > b || b >= c.length ? (S(1281), 0) : c[b];
  }
  switch(a) {
    case 7939:
      return c = U.getSupportedExtensions() || [], c = c.concat(c.map(function(d) {
        return "GL_" + d;
      })), c = c.map(function(d) {
        return $d(d);
      }), c = Nd[a] = c, 0 > b || b >= c.length ? (S(1281), 0) : c[b];
    default:
      return S(1280), 0;
  }
}, emscripten_glGetUniformLocation:function(a, b) {
  b = b ? fb(x, b) : "";
  if (a = Ed[a]) {
    var c = a, d = c.ma, e = c.ub, f;
    if (!d) {
      for (c.ma = d = {}, c.tb = {}, f = 0; f < U.getProgramParameter(c, 35718); ++f) {
        var g = U.getActiveUniform(c, f);
        var k = g.name;
        g = g.size;
        var p = ae(k);
        p = 0 < p ? k.slice(0, p) : k;
        var n = c.Sa;
        c.Sa += g;
        e[p] = [g, n];
        for (k = 0; k < g; ++k) {
          d[n] = k, c.tb[n++] = p;
        }
      }
    }
    c = a.ma;
    d = 0;
    e = b;
    f = ae(b);
    0 < f && (d = parseInt(b.slice(f + 1)) >>> 0, e = b.slice(0, f));
    if ((e = a.ub[e]) && d < e[0] && (d += e[1], c[d] = c[d] || U.getUniformLocation(a, b))) {
      return d;
    }
  } else {
    S(1281);
  }
  return -1;
}, emscripten_glInvalidateFramebuffer:function(a, b, c) {
  for (var d = Td[b], e = 0; e < b; e++) {
    d[e] = D[c + 4 * e >> 2];
  }
  U.invalidateFramebuffer(a, d);
}, emscripten_glInvalidateSubFramebuffer:function(a, b, c, d, e, f, g) {
  for (var k = Td[b], p = 0; p < b; p++) {
    k[p] = D[c + 4 * p >> 2];
  }
  U.invalidateSubFramebuffer(a, k, d, e, f, g);
}, emscripten_glIsSync:function(a) {
  return U.isSync(Ld[a]);
}, emscripten_glIsTexture:function(a) {
  return (a = Hd[a]) ? U.isTexture(a) : 0;
}, emscripten_glLineWidth:function(a) {
  U.lineWidth(a);
}, emscripten_glLinkProgram:function(a) {
  a = Ed[a];
  U.linkProgram(a);
  a.ma = 0;
  a.ub = {};
}, emscripten_glMultiDrawArraysInstancedBaseInstanceWEBGL:function(a, b, c, d, e, f) {
  U.gb.multiDrawArraysInstancedBaseInstanceWEBGL(a, D, b >> 2, D, c >> 2, D, d >> 2, E, e >> 2, f);
}, emscripten_glMultiDrawElementsInstancedBaseVertexBaseInstanceWEBGL:function(a, b, c, d, e, f, g, k) {
  U.gb.multiDrawElementsInstancedBaseVertexBaseInstanceWEBGL(a, D, b >> 2, c, D, d >> 2, D, e >> 2, D, f >> 2, E, g >> 2, k);
}, emscripten_glPixelStorei:function(a, b) {
  3317 == a && (Od = b);
  U.pixelStorei(a, b);
}, emscripten_glReadBuffer:function(a) {
  U.readBuffer(a);
}, emscripten_glReadPixels:function(a, b, c, d, e, f, g) {
  if (2 <= T.version) {
    if (U.Ka) {
      U.readPixels(a, b, c, d, e, f, g);
    } else {
      var k = be(f);
      U.readPixels(a, b, c, d, e, f, k, g >> 31 - Math.clz32(k.BYTES_PER_ELEMENT));
    }
  } else {
    (g = ce(f, e, c, d, g)) ? U.readPixels(a, b, c, d, e, f, g) : S(1280);
  }
}, emscripten_glRenderbufferStorage:function(a, b, c, d) {
  U.renderbufferStorage(a, b, c, d);
}, emscripten_glRenderbufferStorageMultisample:function(a, b, c, d, e) {
  U.renderbufferStorageMultisample(a, b, c, d, e);
}, emscripten_glSamplerParameteri:function(a, b, c) {
  U.samplerParameteri(Kd[a], b, c);
}, emscripten_glSamplerParameteriv:function(a, b, c) {
  U.samplerParameteri(Kd[a], b, D[c >> 2]);
}, emscripten_glScissor:function(a, b, c, d) {
  U.scissor(a, b, c, d);
}, emscripten_glShaderSource:function(a, b, c, d) {
  for (var e = "", f = 0; f < b; ++f) {
    var g = d ? D[d + 4 * f >> 2] : -1, k = D[c + 4 * f >> 2];
    g = k ? fb(x, k, 0 > g ? void 0 : g) : "";
    e += g;
  }
  U.shaderSource(Id[a], e);
}, emscripten_glStencilFunc:function(a, b, c) {
  U.stencilFunc(a, b, c);
}, emscripten_glStencilFuncSeparate:function(a, b, c, d) {
  U.stencilFuncSeparate(a, b, c, d);
}, emscripten_glStencilMask:function(a) {
  U.stencilMask(a);
}, emscripten_glStencilMaskSeparate:function(a, b) {
  U.stencilMaskSeparate(a, b);
}, emscripten_glStencilOp:function(a, b, c) {
  U.stencilOp(a, b, c);
}, emscripten_glStencilOpSeparate:function(a, b, c, d) {
  U.stencilOpSeparate(a, b, c, d);
}, emscripten_glTexImage2D:function(a, b, c, d, e, f, g, k, p) {
  if (2 <= T.version) {
    if (U.fa) {
      U.texImage2D(a, b, c, d, e, f, g, k, p);
    } else if (p) {
      var n = be(k);
      U.texImage2D(a, b, c, d, e, f, g, k, n, p >> 31 - Math.clz32(n.BYTES_PER_ELEMENT));
    } else {
      U.texImage2D(a, b, c, d, e, f, g, k, null);
    }
  } else {
    U.texImage2D(a, b, c, d, e, f, g, k, p ? ce(k, g, d, e, p) : null);
  }
}, emscripten_glTexParameterf:function(a, b, c) {
  U.texParameterf(a, b, c);
}, emscripten_glTexParameterfv:function(a, b, c) {
  U.texParameterf(a, b, F[c >> 2]);
}, emscripten_glTexParameteri:function(a, b, c) {
  U.texParameteri(a, b, c);
}, emscripten_glTexParameteriv:function(a, b, c) {
  U.texParameteri(a, b, D[c >> 2]);
}, emscripten_glTexStorage2D:function(a, b, c, d, e) {
  U.texStorage2D(a, b, c, d, e);
}, emscripten_glTexSubImage2D:function(a, b, c, d, e, f, g, k, p) {
  if (2 <= T.version) {
    if (U.fa) {
      U.texSubImage2D(a, b, c, d, e, f, g, k, p);
    } else if (p) {
      var n = be(k);
      U.texSubImage2D(a, b, c, d, e, f, g, k, n, p >> 31 - Math.clz32(n.BYTES_PER_ELEMENT));
    } else {
      U.texSubImage2D(a, b, c, d, e, f, g, k, null);
    }
  } else {
    n = null, p && (n = ce(k, g, e, f, p)), U.texSubImage2D(a, b, c, d, e, f, g, k, n);
  }
}, emscripten_glUniform1f:function(a, b) {
  U.uniform1f(V(a), b);
}, emscripten_glUniform1fv:function(a, b, c) {
  if (2 <= T.version) {
    b && U.uniform1fv(V(a), F, c >> 2, b);
  } else {
    if (288 >= b) {
      for (var d = de[b - 1], e = 0; e < b; ++e) {
        d[e] = F[c + 4 * e >> 2];
      }
    } else {
      d = F.subarray(c >> 2, c + 4 * b >> 2);
    }
    U.uniform1fv(V(a), d);
  }
}, emscripten_glUniform1i:function(a, b) {
  U.uniform1i(V(a), b);
}, emscripten_glUniform1iv:function(a, b, c) {
  if (2 <= T.version) {
    b && U.uniform1iv(V(a), D, c >> 2, b);
  } else {
    if (288 >= b) {
      for (var d = ee[b - 1], e = 0; e < b; ++e) {
        d[e] = D[c + 4 * e >> 2];
      }
    } else {
      d = D.subarray(c >> 2, c + 4 * b >> 2);
    }
    U.uniform1iv(V(a), d);
  }
}, emscripten_glUniform2f:function(a, b, c) {
  U.uniform2f(V(a), b, c);
}, emscripten_glUniform2fv:function(a, b, c) {
  if (2 <= T.version) {
    b && U.uniform2fv(V(a), F, c >> 2, 2 * b);
  } else {
    if (144 >= b) {
      for (var d = de[2 * b - 1], e = 0; e < 2 * b; e += 2) {
        d[e] = F[c + 4 * e >> 2], d[e + 1] = F[c + (4 * e + 4) >> 2];
      }
    } else {
      d = F.subarray(c >> 2, c + 8 * b >> 2);
    }
    U.uniform2fv(V(a), d);
  }
}, emscripten_glUniform2i:function(a, b, c) {
  U.uniform2i(V(a), b, c);
}, emscripten_glUniform2iv:function(a, b, c) {
  if (2 <= T.version) {
    b && U.uniform2iv(V(a), D, c >> 2, 2 * b);
  } else {
    if (144 >= b) {
      for (var d = ee[2 * b - 1], e = 0; e < 2 * b; e += 2) {
        d[e] = D[c + 4 * e >> 2], d[e + 1] = D[c + (4 * e + 4) >> 2];
      }
    } else {
      d = D.subarray(c >> 2, c + 8 * b >> 2);
    }
    U.uniform2iv(V(a), d);
  }
}, emscripten_glUniform3f:function(a, b, c, d) {
  U.uniform3f(V(a), b, c, d);
}, emscripten_glUniform3fv:function(a, b, c) {
  if (2 <= T.version) {
    b && U.uniform3fv(V(a), F, c >> 2, 3 * b);
  } else {
    if (96 >= b) {
      for (var d = de[3 * b - 1], e = 0; e < 3 * b; e += 3) {
        d[e] = F[c + 4 * e >> 2], d[e + 1] = F[c + (4 * e + 4) >> 2], d[e + 2] = F[c + (4 * e + 8) >> 2];
      }
    } else {
      d = F.subarray(c >> 2, c + 12 * b >> 2);
    }
    U.uniform3fv(V(a), d);
  }
}, emscripten_glUniform3i:function(a, b, c, d) {
  U.uniform3i(V(a), b, c, d);
}, emscripten_glUniform3iv:function(a, b, c) {
  if (2 <= T.version) {
    b && U.uniform3iv(V(a), D, c >> 2, 3 * b);
  } else {
    if (96 >= b) {
      for (var d = ee[3 * b - 1], e = 0; e < 3 * b; e += 3) {
        d[e] = D[c + 4 * e >> 2], d[e + 1] = D[c + (4 * e + 4) >> 2], d[e + 2] = D[c + (4 * e + 8) >> 2];
      }
    } else {
      d = D.subarray(c >> 2, c + 12 * b >> 2);
    }
    U.uniform3iv(V(a), d);
  }
}, emscripten_glUniform4f:function(a, b, c, d, e) {
  U.uniform4f(V(a), b, c, d, e);
}, emscripten_glUniform4fv:function(a, b, c) {
  if (2 <= T.version) {
    b && U.uniform4fv(V(a), F, c >> 2, 4 * b);
  } else {
    if (72 >= b) {
      var d = de[4 * b - 1], e = F;
      c >>= 2;
      for (var f = 0; f < 4 * b; f += 4) {
        var g = c + f;
        d[f] = e[g];
        d[f + 1] = e[g + 1];
        d[f + 2] = e[g + 2];
        d[f + 3] = e[g + 3];
      }
    } else {
      d = F.subarray(c >> 2, c + 16 * b >> 2);
    }
    U.uniform4fv(V(a), d);
  }
}, emscripten_glUniform4i:function(a, b, c, d, e) {
  U.uniform4i(V(a), b, c, d, e);
}, emscripten_glUniform4iv:function(a, b, c) {
  if (2 <= T.version) {
    b && U.uniform4iv(V(a), D, c >> 2, 4 * b);
  } else {
    if (72 >= b) {
      for (var d = ee[4 * b - 1], e = 0; e < 4 * b; e += 4) {
        d[e] = D[c + 4 * e >> 2], d[e + 1] = D[c + (4 * e + 4) >> 2], d[e + 2] = D[c + (4 * e + 8) >> 2], d[e + 3] = D[c + (4 * e + 12) >> 2];
      }
    } else {
      d = D.subarray(c >> 2, c + 16 * b >> 2);
    }
    U.uniform4iv(V(a), d);
  }
}, emscripten_glUniformMatrix2fv:function(a, b, c, d) {
  if (2 <= T.version) {
    b && U.uniformMatrix2fv(V(a), !!c, F, d >> 2, 4 * b);
  } else {
    if (72 >= b) {
      for (var e = de[4 * b - 1], f = 0; f < 4 * b; f += 4) {
        e[f] = F[d + 4 * f >> 2], e[f + 1] = F[d + (4 * f + 4) >> 2], e[f + 2] = F[d + (4 * f + 8) >> 2], e[f + 3] = F[d + (4 * f + 12) >> 2];
      }
    } else {
      e = F.subarray(d >> 2, d + 16 * b >> 2);
    }
    U.uniformMatrix2fv(V(a), !!c, e);
  }
}, emscripten_glUniformMatrix3fv:function(a, b, c, d) {
  if (2 <= T.version) {
    b && U.uniformMatrix3fv(V(a), !!c, F, d >> 2, 9 * b);
  } else {
    if (32 >= b) {
      for (var e = de[9 * b - 1], f = 0; f < 9 * b; f += 9) {
        e[f] = F[d + 4 * f >> 2], e[f + 1] = F[d + (4 * f + 4) >> 2], e[f + 2] = F[d + (4 * f + 8) >> 2], e[f + 3] = F[d + (4 * f + 12) >> 2], e[f + 4] = F[d + (4 * f + 16) >> 2], e[f + 5] = F[d + (4 * f + 20) >> 2], e[f + 6] = F[d + (4 * f + 24) >> 2], e[f + 7] = F[d + (4 * f + 28) >> 2], e[f + 8] = F[d + (4 * f + 32) >> 2];
      }
    } else {
      e = F.subarray(d >> 2, d + 36 * b >> 2);
    }
    U.uniformMatrix3fv(V(a), !!c, e);
  }
}, emscripten_glUniformMatrix4fv:function(a, b, c, d) {
  if (2 <= T.version) {
    b && U.uniformMatrix4fv(V(a), !!c, F, d >> 2, 16 * b);
  } else {
    if (18 >= b) {
      var e = de[16 * b - 1], f = F;
      d >>= 2;
      for (var g = 0; g < 16 * b; g += 16) {
        var k = d + g;
        e[g] = f[k];
        e[g + 1] = f[k + 1];
        e[g + 2] = f[k + 2];
        e[g + 3] = f[k + 3];
        e[g + 4] = f[k + 4];
        e[g + 5] = f[k + 5];
        e[g + 6] = f[k + 6];
        e[g + 7] = f[k + 7];
        e[g + 8] = f[k + 8];
        e[g + 9] = f[k + 9];
        e[g + 10] = f[k + 10];
        e[g + 11] = f[k + 11];
        e[g + 12] = f[k + 12];
        e[g + 13] = f[k + 13];
        e[g + 14] = f[k + 14];
        e[g + 15] = f[k + 15];
      }
    } else {
      e = F.subarray(d >> 2, d + 64 * b >> 2);
    }
    U.uniformMatrix4fv(V(a), !!c, e);
  }
}, emscripten_glUseProgram:function(a) {
  a = Ed[a];
  U.useProgram(a);
  U.Gb = a;
}, emscripten_glVertexAttrib1f:function(a, b) {
  U.vertexAttrib1f(a, b);
}, emscripten_glVertexAttrib2fv:function(a, b) {
  U.vertexAttrib2f(a, F[b >> 2], F[b + 4 >> 2]);
}, emscripten_glVertexAttrib3fv:function(a, b) {
  U.vertexAttrib3f(a, F[b >> 2], F[b + 4 >> 2], F[b + 8 >> 2]);
}, emscripten_glVertexAttrib4fv:function(a, b) {
  U.vertexAttrib4f(a, F[b >> 2], F[b + 4 >> 2], F[b + 8 >> 2], F[b + 12 >> 2]);
}, emscripten_glVertexAttribDivisor:function(a, b) {
  U.vertexAttribDivisor(a, b);
}, emscripten_glVertexAttribIPointer:function(a, b, c, d, e) {
  U.vertexAttribIPointer(a, b, c, d, e);
}, emscripten_glVertexAttribPointer:function(a, b, c, d, e, f) {
  U.vertexAttribPointer(a, b, c, !!d, e, f);
}, emscripten_glViewport:function(a, b, c, d) {
  U.viewport(a, b, c, d);
}, emscripten_glWaitSync:function(a, b, c, d) {
  U.waitSync(Ld[a], b, (c >>> 0) + 4294967296 * d);
}, emscripten_memcpy_big:(a, b, c) => x.copyWithin(a, b, b + c), emscripten_resize_heap:a => {
  var b = x.length;
  a >>>= 0;
  if (2147483648 < a) {
    return !1;
  }
  for (var c = 1; 4 >= c; c *= 2) {
    var d = b * (1 + 0.2 / c);
    d = Math.min(d, a + 100663296);
    var e = Math;
    d = Math.max(a, d);
    a: {
      e = e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - xa.buffer.byteLength + 65535 >>> 16;
      try {
        xa.grow(e);
        Ba();
        var f = 1;
        break a;
      } catch (g) {
      }
      f = void 0;
    }
    if (f) {
      return !0;
    }
  }
  return !1;
}, emscripten_webgl_get_current_context:function() {
  return T ? T.handle : 0;
}, emscripten_webgl_make_context_current:function(a) {
  return la(a) ? 0 : -5;
}, environ_get:(a, b) => {
  var c = 0;
  he().forEach(function(d, e) {
    var f = b + c;
    e = E[a + 4 * e >> 2] = f;
    for (f = 0; f < d.length; ++f) {
      v[e++ >> 0] = d.charCodeAt(f);
    }
    v[e >> 0] = 0;
    c += d.length + 1;
  });
  return 0;
}, environ_sizes_get:(a, b) => {
  var c = he();
  E[a >> 2] = c.length;
  var d = 0;
  c.forEach(function(e) {
    d += e.length + 1;
  });
  E[b >> 2] = d;
  return 0;
}, fd_close:function(a) {
  try {
    var b = Nb(a);
    if (null === b.V) {
      throw new G(8);
    }
    b.Ma && (b.Ma = null);
    try {
      b.m.close && b.m.close(b);
    } catch (c) {
      throw c;
    } finally {
      zb[b.V] = null;
    }
    b.V = null;
    return 0;
  } catch (c) {
    if ("undefined" == typeof ac || "ErrnoError" !== c.name) {
      throw c;
    }
    return c.Z;
  }
}, fd_read:function(a, b, c, d) {
  try {
    a: {
      var e = Nb(a);
      a = b;
      for (var f, g = b = 0; g < c; g++) {
        var k = E[a >> 2], p = E[a + 4 >> 2];
        a += 8;
        var n = e, t = k, w = p, y = f, q = v;
        if (0 > w || 0 > y) {
          throw new G(28);
        }
        if (null === n.V) {
          throw new G(8);
        }
        if (1 === (n.flags & 2097155)) {
          throw new G(8);
        }
        if (16384 === (n.node.mode & 61440)) {
          throw new G(31);
        }
        if (!n.m.read) {
          throw new G(28);
        }
        var r = "undefined" != typeof y;
        if (!r) {
          y = n.position;
        } else if (!n.seekable) {
          throw new G(70);
        }
        var u = n.m.read(n, q, t, w, y);
        r || (n.position += u);
        var z = u;
        if (0 > z) {
          var B = -1;
          break a;
        }
        b += z;
        if (z < p) {
          break;
        }
        "undefined" !== typeof f && (f += z);
      }
      B = b;
    }
    E[d >> 2] = B;
    return 0;
  } catch (C) {
    if ("undefined" == typeof ac || "ErrnoError" !== C.name) {
      throw C;
    }
    return C.Z;
  }
}, fd_seek:function(a, b, c, d, e) {
  b = c + 2097152 >>> 0 < 4194305 - !!b ? (b >>> 0) + 4294967296 * c : NaN;
  try {
    if (isNaN(b)) {
      return 61;
    }
    var f = Nb(a);
    Wb(f, b, d);
    Sa = [f.position >>> 0, (Ra = f.position, 1.0 <= +Math.abs(Ra) ? 0.0 < Ra ? +Math.floor(Ra / 4294967296.0) >>> 0 : ~~+Math.ceil((Ra - +(~~Ra >>> 0)) / 4294967296.0) >>> 0 : 0)];
    D[e >> 2] = Sa[0];
    D[e + 4 >> 2] = Sa[1];
    f.Ma && 0 === b && 0 === d && (f.Ma = null);
    return 0;
  } catch (g) {
    if ("undefined" == typeof ac || "ErrnoError" !== g.name) {
      throw g;
    }
    return g.Z;
  }
}, fd_write:function(a, b, c, d) {
  try {
    a: {
      var e = Nb(a);
      a = b;
      for (var f, g = b = 0; g < c; g++) {
        var k = E[a >> 2], p = E[a + 4 >> 2];
        a += 8;
        var n = e, t = k, w = p, y = f, q = v;
        if (0 > w || 0 > y) {
          throw new G(28);
        }
        if (null === n.V) {
          throw new G(8);
        }
        if (0 === (n.flags & 2097155)) {
          throw new G(8);
        }
        if (16384 === (n.node.mode & 61440)) {
          throw new G(31);
        }
        if (!n.m.write) {
          throw new G(28);
        }
        n.seekable && n.flags & 1024 && Wb(n, 0, 2);
        var r = "undefined" != typeof y;
        if (!r) {
          y = n.position;
        } else if (!n.seekable) {
          throw new G(70);
        }
        var u = n.m.write(n, q, t, w, y, void 0);
        r || (n.position += u);
        var z = u;
        if (0 > z) {
          var B = -1;
          break a;
        }
        b += z;
        "undefined" !== typeof f && (f += z);
      }
      B = b;
    }
    E[d >> 2] = B;
    return 0;
  } catch (C) {
    if ("undefined" == typeof ac || "ErrnoError" !== C.name) {
      throw C;
    }
    return C.Z;
  }
}, glBindFramebuffer:Qd, glGetIntegerv:Yd, invoke_ii:re, invoke_iii:se, invoke_iiii:te, invoke_iiiii:ue, invoke_iiiiii:ve, invoke_iiiiiii:we, invoke_iiiiiiiiii:xe, invoke_v:ye, invoke_vi:ze, invoke_vii:Ae, invoke_viii:Be, invoke_viiii:Ce, invoke_viiiiii:De, invoke_viiiiiii:Ee, invoke_viiiiiiii:Fe, strftime_l:(a, b, c, d) => le(a, b, c, d)};
(function() {
  function a(c) {
    m = c = c.exports;
    xa = m.memory;
    Ba();
    Ca = m.__indirect_function_table;
    Ea.unshift(m.__wasm_call_ctors);
    Ha--;
    l.monitorRunDependencies && l.monitorRunDependencies(Ha);
    if (0 == Ha && (null !== Ia && (clearInterval(Ia), Ia = null), Ja)) {
      var d = Ja;
      Ja = null;
      d();
    }
    return c;
  }
  var b = {env:Ge, wasi_snapshot_preview1:Ge,};
  Ha++;
  l.monitorRunDependencies && l.monitorRunDependencies(Ha);
  if (l.instantiateWasm) {
    try {
      return l.instantiateWasm(b, a);
    } catch (c) {
      ua("Module.instantiateWasm callback failed with error: " + c), ba(c);
    }
  }
  Qa(b, function(c) {
    a(c.instance);
  }).catch(ba);
  return {};
})();
var uc = a => (uc = m.free)(a), Zd = a => (Zd = m.malloc)(a), Ta = l._ma_device__on_notification_unlocked = a => (Ta = l._ma_device__on_notification_unlocked = m.ma_device__on_notification_unlocked)(a);
l._ma_malloc_emscripten = (a, b) => (l._ma_malloc_emscripten = m.ma_malloc_emscripten)(a, b);
l._ma_free_emscripten = (a, b) => (l._ma_free_emscripten = m.ma_free_emscripten)(a, b);
var Ua = l._ma_device_process_pcm_frames_capture__webaudio = (a, b, c) => (Ua = l._ma_device_process_pcm_frames_capture__webaudio = m.ma_device_process_pcm_frames_capture__webaudio)(a, b, c), Va = l._ma_device_process_pcm_frames_playback__webaudio = (a, b, c) => (Va = l._ma_device_process_pcm_frames_playback__webaudio = m.ma_device_process_pcm_frames_playback__webaudio)(a, b, c), qe = () => (qe = m.__errno_location)(), tc = a => (tc = m.__getTypeName)(a);
l.__embind_initialize_bindings = () => (l.__embind_initialize_bindings = m._embind_initialize_bindings)();
var vb = (a, b) => (vb = m.emscripten_builtin_memalign)(a, b), X = (a, b) => (X = m.setThrew)(a, b), Y = () => (Y = m.stackSave)(), Z = a => (Z = m.stackRestore)(a);
l.dynCall_iiiij = (a, b, c, d, e, f) => (l.dynCall_iiiij = m.dynCall_iiiij)(a, b, c, d, e, f);
l.dynCall_viiij = (a, b, c, d, e, f) => (l.dynCall_viiij = m.dynCall_viiij)(a, b, c, d, e, f);
l.dynCall_iiij = (a, b, c, d, e) => (l.dynCall_iiij = m.dynCall_iiij)(a, b, c, d, e);
l.dynCall_viij = (a, b, c, d, e) => (l.dynCall_viij = m.dynCall_viij)(a, b, c, d, e);
l.dynCall_iiji = (a, b, c, d, e) => (l.dynCall_iiji = m.dynCall_iiji)(a, b, c, d, e);
l.dynCall_jiji = (a, b, c, d, e) => (l.dynCall_jiji = m.dynCall_jiji)(a, b, c, d, e);
l.dynCall_iiiji = (a, b, c, d, e, f) => (l.dynCall_iiiji = m.dynCall_iiiji)(a, b, c, d, e, f);
l.dynCall_iij = (a, b, c, d) => (l.dynCall_iij = m.dynCall_iij)(a, b, c, d);
l.dynCall_jii = (a, b, c) => (l.dynCall_jii = m.dynCall_jii)(a, b, c);
l.dynCall_viiiiij = (a, b, c, d, e, f, g, k) => (l.dynCall_viiiiij = m.dynCall_viiiiij)(a, b, c, d, e, f, g, k);
l.dynCall_viji = (a, b, c, d, e) => (l.dynCall_viji = m.dynCall_viji)(a, b, c, d, e);
l.dynCall_ji = (a, b) => (l.dynCall_ji = m.dynCall_ji)(a, b);
l.dynCall_vij = (a, b, c, d) => (l.dynCall_vij = m.dynCall_vij)(a, b, c, d);
l.dynCall_viijii = (a, b, c, d, e, f, g) => (l.dynCall_viijii = m.dynCall_viijii)(a, b, c, d, e, f, g);
l.dynCall_iiiiij = (a, b, c, d, e, f, g) => (l.dynCall_iiiiij = m.dynCall_iiiiij)(a, b, c, d, e, f, g);
l.dynCall_iiiiijj = (a, b, c, d, e, f, g, k, p) => (l.dynCall_iiiiijj = m.dynCall_iiiiijj)(a, b, c, d, e, f, g, k, p);
l.dynCall_iiiiiijj = (a, b, c, d, e, f, g, k, p, n) => (l.dynCall_iiiiiijj = m.dynCall_iiiiiijj)(a, b, c, d, e, f, g, k, p, n);
function re(a, b) {
  var c = Y();
  try {
    return Q(a)(b);
  } catch (d) {
    Z(c);
    if (d !== d + 0) {
      throw d;
    }
    X(1, 0);
  }
}
function Ae(a, b, c) {
  var d = Y();
  try {
    Q(a)(b, c);
  } catch (e) {
    Z(d);
    if (e !== e + 0) {
      throw e;
    }
    X(1, 0);
  }
}
function ze(a, b) {
  var c = Y();
  try {
    Q(a)(b);
  } catch (d) {
    Z(c);
    if (d !== d + 0) {
      throw d;
    }
    X(1, 0);
  }
}
function te(a, b, c, d) {
  var e = Y();
  try {
    return Q(a)(b, c, d);
  } catch (f) {
    Z(e);
    if (f !== f + 0) {
      throw f;
    }
    X(1, 0);
  }
}
function Be(a, b, c, d) {
  var e = Y();
  try {
    Q(a)(b, c, d);
  } catch (f) {
    Z(e);
    if (f !== f + 0) {
      throw f;
    }
    X(1, 0);
  }
}
function Ce(a, b, c, d, e) {
  var f = Y();
  try {
    Q(a)(b, c, d, e);
  } catch (g) {
    Z(f);
    if (g !== g + 0) {
      throw g;
    }
    X(1, 0);
  }
}
function ye(a) {
  var b = Y();
  try {
    Q(a)();
  } catch (c) {
    Z(b);
    if (c !== c + 0) {
      throw c;
    }
    X(1, 0);
  }
}
function we(a, b, c, d, e, f, g) {
  var k = Y();
  try {
    return Q(a)(b, c, d, e, f, g);
  } catch (p) {
    Z(k);
    if (p !== p + 0) {
      throw p;
    }
    X(1, 0);
  }
}
function se(a, b, c) {
  var d = Y();
  try {
    return Q(a)(b, c);
  } catch (e) {
    Z(d);
    if (e !== e + 0) {
      throw e;
    }
    X(1, 0);
  }
}
function Ee(a, b, c, d, e, f, g, k) {
  var p = Y();
  try {
    Q(a)(b, c, d, e, f, g, k);
  } catch (n) {
    Z(p);
    if (n !== n + 0) {
      throw n;
    }
    X(1, 0);
  }
}
function xe(a, b, c, d, e, f, g, k, p, n) {
  var t = Y();
  try {
    return Q(a)(b, c, d, e, f, g, k, p, n);
  } catch (w) {
    Z(t);
    if (w !== w + 0) {
      throw w;
    }
    X(1, 0);
  }
}
function ue(a, b, c, d, e) {
  var f = Y();
  try {
    return Q(a)(b, c, d, e);
  } catch (g) {
    Z(f);
    if (g !== g + 0) {
      throw g;
    }
    X(1, 0);
  }
}
function Fe(a, b, c, d, e, f, g, k, p) {
  var n = Y();
  try {
    Q(a)(b, c, d, e, f, g, k, p);
  } catch (t) {
    Z(n);
    if (t !== t + 0) {
      throw t;
    }
    X(1, 0);
  }
}
function ve(a, b, c, d, e, f) {
  var g = Y();
  try {
    return Q(a)(b, c, d, e, f);
  } catch (k) {
    Z(g);
    if (k !== k + 0) {
      throw k;
    }
    X(1, 0);
  }
}
function De(a, b, c, d, e, f, g) {
  var k = Y();
  try {
    Q(a)(b, c, d, e, f, g);
  } catch (p) {
    Z(k);
    if (p !== p + 0) {
      throw p;
    }
    X(1, 0);
  }
}
var He;
Ja = function Ie() {
  He || Je();
  He || (Ja = Ie);
};
function Je() {
  function a() {
    if (!He && (He = !0, l.calledRun = !0, !ya)) {
      l.noFSInit || Yb || (Yb = !0, Xb(), l.stdin = l.stdin, l.stdout = l.stdout, l.stderr = l.stderr, l.stdin ? $b("stdin", l.stdin) : Tb("/dev/tty", "/dev/stdin"), l.stdout ? $b("stdout", null, l.stdout) : Tb("/dev/tty", "/dev/stdout"), l.stderr ? $b("stderr", null, l.stderr) : Tb("/dev/tty1", "/dev/stderr"), Vb("/dev/stdin", 0), Vb("/dev/stdout", 1), Vb("/dev/stderr", 1));
      Cb = !1;
      Xa(Ea);
      aa(l);
      if (l.onRuntimeInitialized) {
        l.onRuntimeInitialized();
      }
      if (l.postRun) {
        for ("function" == typeof l.postRun && (l.postRun = [l.postRun]); l.postRun.length;) {
          var b = l.postRun.shift();
          Fa.unshift(b);
        }
      }
      Xa(Fa);
    }
  }
  if (!(0 < Ha)) {
    if (l.preRun) {
      for ("function" == typeof l.preRun && (l.preRun = [l.preRun]); l.preRun.length;) {
        Ga();
      }
    }
    Xa(Da);
    0 < Ha || (l.setStatus ? (l.setStatus("Running..."), setTimeout(function() {
      setTimeout(function() {
        l.setStatus("");
      }, 1);
      a();
    }, 1)) : a());
  }
}
if (l.preInit) {
  for ("function" == typeof l.preInit && (l.preInit = [l.preInit]); 0 < l.preInit.length;) {
    l.preInit.pop()();
  }
}
Je();



  return moduleArg.ready
}

);
})();
export default Rive;